import { Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import {  Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { CommitteeService } from 'src/app/services/committee.service';
import { AlertComponent } from '../../alert/alert.component';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { KmpmasterService } from 'src/app/services/kmpmaster.service';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { environment } from 'src/environments/environment';
import { DataArray } from 'src/app/helpers/datalist';
declare var $: any;
declare var jQuery: any;
import * as _ from 'lodash';
var moment = require('moment');

@Component({
  selector: 'app-kmpadd-edit',
  templateUrl: './kmpadd-edit.component.html',
  styleUrls: ['./kmpadd-edit.component.css']
})
export class KMPAddEditComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfKMPship: DataTables.Settings = {};
  dtOptionsOfSubKMP: DataTables.Settings = {};
  dtOptionsOfRelative: DataTables.Settings = {};
  dtTriggerKMPship: Subject<any> = new Subject();
  dtTriggerSubKMP: Subject<any> = new Subject();
  dtTriggerRelative: Subject<any> = new Subject();
  showMarridYes: boolean;
  kmpPersonalForm: FormGroup;
  kmpProfessionalForm: FormGroup;
  kmpContactForm: FormGroup;
  subKmpForm: FormGroup;
  kmpshipForm: FormGroup;
  relativeForm: FormGroup;
  DateOfBirthModel: any;
  stateListArray: any;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  designationArray: any;
  bodycorporateArray: any;
  bodycorporateArrayInRelative: any;
  AppointmentDateModel: any;
  FilingMR1DateModel: any;
  FillingMR2DateModel: any;
  AppointmentDIR12FillingDateModel: any;
  AppointmentCompletionDateModel: any;
  CessationDateModel: any;
  EformDIR12FilingDateModel: any;
  BoardResolutionDateModel: any;
  natureOfIntrestArray: any;
  natureOfIntrestArrayInRelative: any;
  relationArray: any;
  committeeArray: any;
  instituteArray: any;
  ReAppointmentDateModel: any;
  kmpshipArray: any;
  subkmpArray: any;
  dirAppointmentDateModel: any;
  dirCessationDateModel: any;
  AcquisitionDateModel: any;
  DisposalDateModel: any;
  searchPAN: string;
  relativesArray: any;
  IntrestDateModel: any;
  IntrestChangeDateModel: any;
  deleteRelativeID: any;
  showDormantState: any;
  NumberOfSecuritiesModel: any;
  NumberOfSharesDisposedModel: any;
  cumulativeBalanceModel: any;
  IsNumberOfSharesLarge: boolean;
  IsNumberOfSecurityLess: boolean;
  error: any = { isError: false, errorMessage: '' };
  deleteKmpshipID: any;
  deleteSubKmpID: any;
  selectDirector: any;
  IsOtherInstitute: boolean;
  showShareHolding: boolean;
  showCIN: boolean;
  showOtherCompany: boolean;
  showShareholdingInRelative: boolean;
  showOtherDesignation: boolean;
  showOtherCompanyForRelative: boolean;
  showOtherNatureForRelative: boolean;
  showDormantStateRelative: boolean;
  showCINRelative: boolean;
  showOtherNatureOfInterest: boolean;
  showCommitee: boolean;
  showKmpOtherDesignation: boolean;
  showOtherCommitee: boolean;
  FutureCessationDate: NgbDateStruct;
  FutureReappointmentDate: NgbDateStruct;
  FutureDIR12FillingDate: NgbDateStruct;
  IsDIR12FillingDatePriorInProfessional: boolean;
  IsReappointmentDatePriorInProfessional: boolean;
  IsCessationDatePriorInProfessional: boolean;
  FutureCessationDateInKMPship: any;
  IsCessationDatePriorInKMPship: boolean;
  FromDateModelInKMPship: any;
  ToDateModelInKMPship: any;
  FromDateModelInSubKMP: any;
  ToDateModelInSubKMP: any;
  FromDateModelInRelative: any;
  ToDateModelInRelative: any;
  directorArray: any;
  FutureDisposalDateInSubKmp: NgbDateStruct;
  IsDisposalDatePriorInSubKmp: boolean;
  IsReappointmentDateLaterInProfessional: boolean;
  globalKmpshipID: any;
  globalSubKmpID: any;
  globalRelativeID: any;
  isDateOfBirthValid: boolean;
  FutureIntrestChangeDate: NgbDateStruct;
  IsInterestChangeDatePriorInRelative = false;
  futureFromDateInDisclosure: NgbDateStruct;
  futureToDateInDisclosure: NgbDateStruct;
  futureToDateInDetailsOfSecurity: NgbDateStruct;
  futureFromDateInDetailsOfSecurity: NgbDateStruct;
  futureFromDateInRelative: NgbDateStruct;
  futureToDateInRelative: NgbDateStruct;
  response: boolean;
  activeclassflag: boolean;
  dateOfIncorpOfCompany: any;
  disabledAppointmentDate: boolean = false;


  showMarridYesClick() {

    this.showMarridYes = true;
  }
  hideMarridYesClick() {

    this.showMarridYes = false;
  }
  TodayDate: NgbDateStruct;
  constructor(private DirectorMasterService: DirectorMasterService,
    private KmpMasterService: KmpmasterService,
    formBuilder: FormBuilder,
    private alert: AlertComponent,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction,
    private meetingService: MeetingMasterService,
    private authAlert: AuthAlertComponent,
    private committeeService: CommitteeService) {
    this.response = false;
  }
  back() { 
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['KMP']  } }],
      { relativeTo: this.activatedRoute.parent });
        // this.location.back(); 
      }

  ngOnInit() {

    localStorage.setItem('checkdin', " ");
    this.getInCorpDate();

    $("#saveUpdateKMPProfessionalDetails").html('<i class="fa fa-save"></i>Save');
    localStorage.setItem('checktab', '');
    var checktabstring = localStorage.getItem('checktab')

    this.activeclassflag = checktabstring.includes("checktab");

    console.log("url", checktabstring.includes("checktab"));
    this.environmentSettings = environment;

    this.selectDirector = false;
    this.showDormantState = false;
    this.IsOtherInstitute = false;
    this.showShareHolding = false;
    this.showCIN = false;
    this.showDormantStateRelative = false;
    this.showCINRelative = false;
    this.showOtherCompany = false;
    this.showOtherDesignation = false;
    this.showOtherCompanyForRelative = false;
    this.showOtherNatureForRelative = false;
    this.showCommitee = false;
    this.showOtherCommitee = false;
    this.IsDIR12FillingDatePriorInProfessional = false;
    this.IsReappointmentDatePriorInProfessional = false;
    this.IsCessationDatePriorInProfessional = false;
    this.isDateOfBirthValid = true;
    $("#firstNameFocus").focus();

    this.dtOptionsOfKMPship = {
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      destroy: true,
      pagingType: 'full_numbers',
      scrollY: "250px",
      scrollCollapse: true,
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }]
    };
    this.dtOptionsOfSubKMP = {
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      destroy: true,
      pagingType: 'full_numbers',
      scrollY: "250px",
      scrollCollapse: true,
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }]
    };
    this.dtOptionsOfRelative = {
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      destroy: true,
      pagingType: 'full_numbers',
      scrollY: "250px",
      scrollCollapse: true,
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [2] }]
    };
    this.getAllNations();
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    this.showMarridYes = false;
    localStorage.removeItem('KmpID');
    this.activatedRoute.params.subscribe(params => {
      if (params['kmpId'] != undefined) {

        var data = {
          module: 'KMP',
          ID: params['kmpId'],
          CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        this.meetingService.authonticateDataForComapnay(data).subscribe(meetingAccess => {
          if (meetingAccess.status == 0) {

            localStorage.setItem('updateKmpId', params['kmpId']);
            console.log('localStorage.setItem updateKmpId', localStorage.getItem('updateKmpId'));
            this.loadKmpDetails(params['kmpId']);
            $("#saveUpdateKMPPersonal").html('<i class="fa fa-save"></i>Update');
            $('#breadCrumbAddKMPTitle, #pageTitle').html("KMP Details");

          } else {

            this.authAlert.validateModuleWithPermissions('KMP', params['kmpId'], meetingAccess.companyID, 'edit')

          }

        })

      }
      else {
        $("#saveUpdateKMPPersonal").html('<i class="fa fa-save"></i>Save');
        $("#saveUpdateKMPProfessionalDetails").html('<i class="fa fa-save"></i>Save');
        $("#saveUpdateKMPContactDetails").html('<i class="fa fa-save"></i>Save');
        localStorage.removeItem('updateKmpId');
        $('#breadCrumbAddKMPTitle, #pageTitle').html("Add New KMP");
      }
    });
    this.natureOfIntrestArrayInRelative = DataArray.NatureOfIntrest;
    this.relationArray = DataArray.Relation;
    this.committeeArray = DataArray.Committee;
    this.showShareholdingInRelative = false;
    console.log('this.instituteArray', this.instituteArray);
    this.kmpPersonalForm = new FormGroup({
      FirstName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z.'][a-zA-Z.' ]*$")]),
      MiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      LastName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      FatherFirstName: new FormControl('', [Validators.pattern("^[a-zA-Z.'][a-zA-Z.' ]*$")]),
      FatherMiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      FatherLastName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      MotherFirstName: new FormControl('', [Validators.pattern("^[a-zA-Z.'][a-zA-Z.' ]*$")]),
      MotherMiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      MotherLastName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      DateOfBirth: new FormControl('', []),
      BirthPlace: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      Gender: new FormControl('', [Validators.required]),
      Nationality: new FormControl('', []),
      Resident: new FormControl('', []),
      Occupation: new FormControl('', []),
      EmailID: new FormControl('', [Validators.required]),
      EducationalQualification: new FormControl('', []),
      PAN: new FormControl('', [Validators.required, Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      IsMarried: new FormControl('', []),
      SpouseFirstName: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      SpouseMiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      SpouseLastName: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
    });

    this.kmpProfessionalForm = new FormGroup({
      MembershipNumber: new FormControl(''),
      Din: new FormControl('', [Validators.pattern("^([0-9]){8}?$")]),
      Designation: new FormControl('', [Validators.required]),
      BoardResolutionDate: new FormControl('', []),
      AppointmentDate: new FormControl('', [Validators.required]),
      ReAppointmentDate: new FormControl('', []),
      CessationDate: new FormControl('', []),
      AppointmentCompletionDate: new FormControl('', []),
      Tenure: new FormControl('', []),
      ExpertiseFunctionalAreas: new FormControl('', []),
      FilingMR1Date: new FormControl('', []),
      FillingMR2Date: new FormControl('', []),
      EformDIR12FilingDate: new FormControl('', []),
      Institute: new FormControl('', []),
      OtherInstitute: new FormControl('', []),
      OtherDesignation: new FormControl('', []),
      DirectorID: new FormControl('', []),
    });

    this.kmpContactForm = new FormGroup({
      isAddressSame: new FormControl('', []),
      PermenantResidentialAddress: new FormGroup({
        Line1: new FormControl('', []),
        Line2: new FormControl('', []),
        City: new FormControl('', []),
        Country: new FormControl('', []),
        State: new FormControl('', []),
        PinCode: new FormControl('', []),
      }),
      PresentResidentialAddress:
        new FormGroup({
          Line1: new FormControl('', []),
          Line2: new FormControl('', []),
          City: new FormControl('', []),
          Country: new FormControl('', []),
          State: new FormControl('', []),
          PinCode: new FormControl('', []),
        }),
      OfficeAddress: new FormGroup({
        Line1: new FormControl('', []),
        Line2: new FormControl('', []),
        City: new FormControl('', []),
        Country: new FormControl('', []),
        State: new FormControl('', []),
        PinCode: new FormControl('', []),
      }),
      OfficeTelephoneNumber: new FormControl('', []),
      ResidentTelephoneNumber: new FormControl('', []),
      Fax: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      AadhaarNumber: new FormControl('', []),
      IdentityNumber: new FormControl('', []),
      PassportNumber: new FormControl('', []),
      DrivingLicenseNumber: new FormControl('', []),
    });

    this.kmpshipForm = new FormGroup({
      OfficeName: new FormControl('', [Validators.required]),
      OfficeType: new FormControl('', []),
      CIN: new FormControl('', [Validators.pattern("^([a-zA-Z]){1}([0-9]){5}([a-zA-Z]){2}([0-9]){4}([a-zA-Z]){3}([0-9]){6}?$")]),
      AppointmentDate: new FormControl('', [Validators.required]),
      NatureOfIntrest: new FormControl('', [Validators.required]),
      CessationDate: new FormControl(''),
      Designation: new FormControl(''),
      PAN: new FormControl('', []),
      ShareHolding: new FormControl('', []),
      DormantCompany: new FormControl('', []),
      OtherCompany: new FormControl('', []),
      OtherDesignation: new FormControl('', []),
      OtherNatureOfInterest: new FormControl('', []),
      CommitteeType: new FormControl('', []),
      OtherCommittee: new FormControl('', []),
    });

    this.subKmpForm = new FormGroup({
      CompanyName: new FormControl('', [Validators.required]),
      NumberOfSecurities: new FormControl('', [Validators.required]),
      SecurityDescription: new FormControl('', [Validators.required]),
      SecurityNominalValue: new FormControl('', []),
      AcquisitionDate: new FormControl('', [Validators.required]),
      AcquisitionPaidPrize: new FormControl('', []),
      AcquisitionOtherPrize: new FormControl('', []),
      DisposalDate: new FormControl('', []),
      NumberOfSharesDisposed: new FormControl('', []),
      DisposalPrize: new FormControl('', []),
      DisposalReceivedPrize: new FormControl('', []),
      CumulativePrize: new FormControl('', []),
      AcquisitionSecuritiesMode: new FormControl('', []),
      HoldingMode: new FormControl('', []),
      PledgedSecurities: new FormControl('', []),
      Shareholding: new FormControl('', [])
    });

    this.relativeForm = new FormGroup({
      RelativeName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      Relationship: new FormControl('', [Validators.required]),
      RelativePAN: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      FirmName: new FormControl('', []),
      CompanyPAN: new FormControl('', []),
      FirmType: new FormControl('', []),
      NatureOfIntrest: new FormControl('', []),
      IntrestDate: new FormControl('', []),
      IntrestChange: new FormControl('', []),
      IntrestChangeDate: new FormControl('', []),
      Shareholding: new FormControl('', []),
      CIN: new FormControl('', [Validators.pattern("^([a-zA-Z]){1}([0-9]){5}([a-zA-Z]){2}([0-9]){4}([a-zA-Z]){3}([0-9]){6}?$")]),
      DormantCompany: new FormControl('', []),
      OtherCompanyForRelative: new FormControl('', []),
      OtherNatureOfIntrestForRelative: new FormControl('', []),
      CommitteeType: new FormControl('', []),
      OtherCommittee: new FormControl('', []),
    });

    this.designationArray = DataArray.KmpDesignation;
    this.stateListArray = DataArray.stateList;
    this.getCompanyTypeInDisclosureOfIntrest();
    this.getNatureOfInterestInDisclosureOfIntrest();
    this.bodycorporateArrayInRelative = DataArray.BodiesCorporate;
    this.setControls();

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };
  }


  getInCorpDate() {
    this.dateOfIncorpOfCompany = "";
    this.committeeService.getInCorpDateOfCompany().subscribe(companyDateOfIncorp => {
      let dt = new Date(this.commonFunction.setFormatDate(companyDateOfIncorp.CompanyDetails[0].DateOfIncorporation))
      this.dateOfIncorpOfCompany = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      // console.log('companyDateOfIncorpcompanyDateOfIncorp--------------------------->>>>',this.dateOfIncorpOfCompany);
      // let dt1 = new Date();
      // this.futureDate = { month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() }
    })
  }

  public noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }



  directorIsAvailable: boolean = false;
  availableDirectorID: any = null

  loadKmpDetails(kmpId) {
    let dt;

    if (!this.environmentSettings.PSS) {
      this.kmpPersonalForm.controls['EmailID'].disable();
    }

    this.KmpMasterService.getKmpDetails(kmpId)
      .subscribe((kmp:any) => {
        if (kmp.status == 0) {
           
          $('#breadCrumbAddKMPTitle, #pageTitle').html("KMP Details (" + kmp.kmpMasterResult[0].FirstName + " " + kmp.kmpMasterResult[0].LastName + ")");
          this.kmpPersonalForm.controls.FirstName.setValue(kmp.kmpMasterResult[0].FirstName);
          this.kmpPersonalForm.controls.MiddleName.setValue(kmp.kmpMasterResult[0].MiddleName);
          this.kmpPersonalForm.controls.LastName.setValue(kmp.kmpMasterResult[0].LastName);
          this.kmpPersonalForm.controls.FatherFirstName.setValue(kmp.kmpMasterResult[0].FatherFirstName);
          this.kmpPersonalForm.controls.FatherMiddleName.setValue(kmp.kmpMasterResult[0].FatherMiddleName);
          this.kmpPersonalForm.controls.FatherLastName.setValue(kmp.kmpMasterResult[0].FatherLastName);
          this.kmpPersonalForm.controls.MotherFirstName.setValue(kmp.kmpMasterResult[0].MotherFirstName);
          this.kmpPersonalForm.controls.MotherMiddleName.setValue(kmp.kmpMasterResult[0].MotherMiddleName);
          this.kmpPersonalForm.controls.MotherLastName.setValue(kmp.kmpMasterResult[0].MotherLastName);
          this.kmpPersonalForm.controls.MotherLastName.setValue(kmp.kmpMasterResult[0].MotherLastName);
          this.kmpPersonalForm.controls.EmailID.setValue(kmp.kmpMasterResult[0].EmailID);
          console.log('Datatatata---->>', kmp.kmpMasterResult[0].kmpAsDirector.isAvailable);
          console.log('Datatatata---->>', kmp.kmpMasterResult[0].kmpAsDirector.directorID);
          this.directorIsAvailable = kmp.kmpMasterResult[0].kmpAsDirector.isAvailable;
          this.availableDirectorID = kmp.kmpMasterResult[0].kmpAsDirector.directorID;
          if (kmp.kmpMasterResult[0].DateOfBirth != null) {
            dt = new Date(this.setFormatDate(kmp.kmpMasterResult[0].DateOfBirth));
            this.DateOfBirthModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
          }
          this.kmpPersonalForm.controls.BirthPlace.setValue(kmp.kmpMasterResult[0].BirthPlace);
          if (kmp.kmpMasterResult[0].Gender == 'Male') {
            this.kmpPersonalForm.controls.Gender.setValue('Male');
          }
          else if (kmp.kmpMasterResult[0].Gender == 'Female') {
            this.kmpPersonalForm.controls.Gender.setValue('Female');
          }
          else if (kmp.kmpMasterResult[0].Gender == 'Transgender') {
            this.kmpPersonalForm.controls.Gender.setValue('Transgender');
          }
          if (kmp.kmpMasterResult[0].Nationality != null) {
            this.kmpPersonalForm.controls.Nationality.setValue(kmp.kmpMasterResult[0].Nationality);
          }
          else {
            this.kmpPersonalForm.controls.Nationality.setValue(null);
          }
          this.kmpPersonalForm.controls.Resident.setValue(kmp.kmpMasterResult[0].Resident);
          this.kmpPersonalForm.controls.Occupation.setValue(kmp.kmpMasterResult[0].Occupation);
          this.kmpPersonalForm.controls.EducationalQualification.setValue(kmp.kmpMasterResult[0].EducationalQualification);
          this.kmpPersonalForm.controls.PAN.setValue(kmp.kmpMasterResult[0].PAN);
          if (kmp.kmpMasterResult[0].IsMarried) {
            this.kmpPersonalForm.controls.IsMarried.setValue('true');
            this.kmpPersonalForm.controls.SpouseFirstName.setValue(kmp.kmpMasterResult[0].SpouseFirstName);
            this.kmpPersonalForm.controls.SpouseMiddleName.setValue(kmp.kmpMasterResult[0].SpouseMiddleName);
            this.kmpPersonalForm.controls.SpouseLastName.setValue(kmp.kmpMasterResult[0].SpouseLastName);
            this.showMarridYes = true;
          }
          else {
            this.showMarridYes = false;
          }
          if (kmp.kmpDetails[0].KmpProfession[0] != undefined) {
            localStorage.setItem('professionalDetailId', kmp.kmpDetails[0].KmpProfession[0]._id);
            $("#saveUpdateKMPProfessionalDetails").html('<i class="fa fa-save"></i>Update');
            this.kmpProfessionalForm.controls.MembershipNumber.setValue(kmp.kmpDetails[0].KmpProfession[0].MembershipNumber);
            this.kmpProfessionalForm.controls.Din.setValue(kmp.kmpDetails[0].KmpProfession[0].Din ? kmp.kmpDetails[0].KmpProfession[0].Din : null);
            this.kmpProfessionalForm.controls.Designation.setValue(kmp.kmpDetails[0].KmpProfession[0].Designation);
            if (kmp.kmpDetails[0].KmpProfession[0].Designation == "Others") {
              this.showKmpOtherDesignation = true;
              this.kmpProfessionalForm.controls.OtherDesignation.setValue(kmp.kmpDetails[0].KmpProfession[0].OtherDesignation);
            }
            else {
              this.showKmpOtherDesignation = false;
            }
            if (kmp.kmpDetails[0].KmpProfession[0].BoardResolutionDate != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].BoardResolutionDate));
              this.BoardResolutionDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (kmp.kmpDetails[0].KmpProfession[0].AppointmentDate != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].AppointmentDate));
              this.AppointmentDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (kmp.kmpDetails[0].KmpProfession[0].FilingMR1Date != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].FilingMR1Date));
              this.FilingMR1DateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (kmp.kmpDetails[0].KmpProfession[0].FillingMR2Date != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].FillingMR2Date));
              this.FillingMR2DateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (kmp.kmpDetails[0].KmpProfession[0].EformDIR12FilingDate != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].EformDIR12FilingDate));
              this.EformDIR12FilingDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (kmp.kmpDetails[0].KmpProfession[0].ReAppointmentDate != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].ReAppointmentDate));
              this.ReAppointmentDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (kmp.kmpDetails[0].KmpProfession[0].CessationDate != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].CessationDate));
              this.CessationDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (kmp.kmpDetails[0].KmpProfession[0].AppointmentCompletionDate != null) {
              dt = new Date(this.setFormatDate(kmp.kmpDetails[0].KmpProfession[0].AppointmentCompletionDate));
              this.AppointmentCompletionDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            this.kmpProfessionalForm.controls.ExpertiseFunctionalAreas.setValue(kmp.kmpDetails[0].KmpProfession[0].ExpertiseFunctionalAreas);
            this.kmpProfessionalForm.controls.Tenure.setValue(kmp.kmpDetails[0].KmpProfession[0].Tenure);
            if (kmp.kmpDetails[0].KmpProfession[0].Institute != "") {
              this.kmpProfessionalForm.controls.Institute.setValue(kmp.kmpDetails[0].KmpProfession[0].Institute);
              if (kmp.kmpDetails[0].KmpProfession[0].Institute == "Other") {
                this.IsOtherInstitute = true;
                this.kmpProfessionalForm.controls.OtherInstitute.setValue(kmp.kmpDetails[0].KmpProfession[0].OtherInstitute);
              }
              else {
                this.IsOtherInstitute = false;
              }
            }
            else {
              this.IsOtherInstitute = false;
              this.kmpProfessionalForm.controls.Institute.setValue(null);
              this.kmpProfessionalForm.controls.OtherInstitute.setValue(null);
            }
            if (kmp.kmpDetails[0].KmpProfession[0].DirectorID != null) {
              this.directorArray = [];
              this.selectDirector = true;
              this.KmpMasterService.getDirectorsByDesignation(kmp.kmpDetails[0].KmpProfession[0].Designation)
                .subscribe(director => {
                  if (director.status == 0) {
                     
                    this.directorArray = this.commonFunction.sortByKey(director.directorData, "FirstName");
                  }
                });
              this.kmpProfessionalForm.controls.DirectorID.setValue(kmp.kmpDetails[0].KmpProfession[0].DirectorID);
            }
          }
          else {
            localStorage.removeItem('professionalDetailId');
            $("#saveUpdateKMPProfessionalDetails").html('<i class="fa fa-save"></i>Save');
          }
          if (kmp.kmpDetails[0].KmpContact[0] != undefined) {
            localStorage.setItem('contactDetailId', kmp.kmpDetails[0].KmpContact[0]._id);
            $("#saveUpdateKMPContactDetails").html('<i class="fa fa-save"></i>Update');
            this.kmpContactForm.controls.OfficeTelephoneNumber.setValue(kmp.kmpDetails[0].KmpContact[0].OfficeTelephoneNumber);
            this.kmpContactForm.controls.ResidentTelephoneNumber.setValue(kmp.kmpDetails[0].KmpContact[0].ResidentTelephoneNumber);
            this.kmpContactForm.controls.Fax.setValue(kmp.kmpDetails[0].KmpContact[0].Fax);
            this.kmpContactForm.controls.MobileNumber.setValue(kmp.kmpDetails[0].KmpContact[0].MobileNumber);
            this.kmpContactForm.controls.AadhaarNumber.setValue(kmp.kmpDetails[0].KmpContact[0].AadhaarNumber);
            this.kmpContactForm.controls.IdentityNumber.setValue(kmp.kmpDetails[0].KmpContact[0].IdentityNumber);
            this.kmpContactForm.controls.PassportNumber.setValue(kmp.kmpDetails[0].KmpContact[0].PassportNumber);
            this.kmpContactForm.controls.DrivingLicenseNumber.setValue(kmp.kmpDetails[0].KmpContact[0].DrivingLicenseNumber);
            this.kmpContactForm.controls.PassportNumber.setValue(kmp.kmpDetails[0].KmpContact[0].PassportNumber);
            this.OfficeAddress.controls.Line1.setValue(kmp.kmpDetails[0].KmpContact[0].OfficeAddress.Line1);
            this.OfficeAddress.controls.Line2.setValue(kmp.kmpDetails[0].KmpContact[0].OfficeAddress.Line2);
            if (kmp.kmpDetails[0].KmpContact[0].OfficeAddress.Country != "") {
              this.OfficeAddress.controls.Country.setValue(kmp.kmpDetails[0].KmpContact[0].OfficeAddress.Country);
            }
            else {
              this.OfficeAddress.controls.Country.setValue(null);
            }
            if (kmp.kmpDetails[0].KmpContact[0].OfficeAddress.State != "") {
              this.OfficeAddress.controls.State.setValue(kmp.kmpDetails[0].KmpContact[0].OfficeAddress.State);
            }
            else {
              this.OfficeAddress.controls.State.setValue(null);
            }
            this.OfficeAddress.controls.City.setValue(kmp.kmpDetails[0].KmpContact[0].OfficeAddress.City);
            this.OfficeAddress.controls.PinCode.setValue(kmp.kmpDetails[0].KmpContact[0].OfficeAddress.PinCode);

            this.PermenantResidentialAddress.controls.Line1.setValue(kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.Line1);
            this.PermenantResidentialAddress.controls.Line2.setValue(kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.Line2);
            if (kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.Country != "") {
              this.PermenantResidentialAddress.controls.Country.setValue(kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.Country);
            }
            else {
              this.PermenantResidentialAddress.controls.Country.setValue(null);
            }
            if (kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.State != "") {
              this.PermenantResidentialAddress.controls.State.setValue(kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.State);
            }
            else {
              this.PermenantResidentialAddress.controls.State.setValue(null);
            }
            this.PermenantResidentialAddress.controls.City.setValue(kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.City);
            this.PermenantResidentialAddress.controls.PinCode.setValue(kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.PinCode);
            // if (kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.PinCode == kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.PinCode) {    
            if (kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.PinCode == kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.PinCode
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Line1 == kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.Line1
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Line2 == kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.Line2
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.State == kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.State
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Country == kmp.kmpDetails[0].KmpContact[0].PermenantResidentialAddress.Country
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.PinCode != ""
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Line1 != ""
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Line2 != ""
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.State != ""
              && kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Country != "") {
              this.kmpContactForm.controls.isAddressSame.setValue(true);
              this.kmpContactForm.controls.isAddressSame.setValue("true");
            } else {
              this.kmpContactForm.controls.isAddressSame.setValue(false);
              this.kmpContactForm.controls.isAddressSame.setValue("false");
            }
            this.PresentResidentialAddress.controls.Line1.setValue(kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Line1);
            this.PresentResidentialAddress.controls.Line2.setValue(kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Line2);
            if (kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Country != "") {
              this.PresentResidentialAddress.controls.Country.setValue(kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.Country);
            }
            else {
              this.PresentResidentialAddress.controls.Country.setValue(null);
            }
            if (kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.State != "") {
              this.PresentResidentialAddress.controls.State.setValue(kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.State);
            }
            else {
              this.PresentResidentialAddress.controls.State.setValue(null);
            }
            this.PresentResidentialAddress.controls.City.setValue(kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.City);
            this.PresentResidentialAddress.controls.PinCode.setValue(kmp.kmpDetails[0].KmpContact[0].PresentResidentialAddress.PinCode);

          }
          else {
            localStorage.removeItem('contactDetailId');
            $("#saveUpdateKMPContactDetails").html('<i class="fa fa-save"></i>Save');
          }
          if (kmp.kmpDetails[0].KmpshipData != undefined) {
            // var table = $('#kmpshipTable').DataTable({ destroy: true });
            // table.destroy();
            // this.kmpshipArray = kmp.kmpDetails[0].KmpshipData;
            // console.log('kmpshiparray', this.kmpshipArray);
            // this.dtTriggerKMPship.next();
            const self = this;
            this.getKMPship(function (response) {
              self.kmpshipArray = response.kmpshipData;
              self.dtTriggerKMPship.next();
            });
          }
          if (kmp.kmpDetails[0].SubKmpData != undefined) {
            // var table = $('#subKmpTable').DataTable({ destroy: true });
            // table.destroy();
            // this.subkmpArray = kmp.kmpDetails[0].SubKmpData;
            // this.dtTriggerSubKMP.next();            
            const self = this;
            this.getSubKMP(function (response) {
              self.subkmpArray = response.subKMPData;
              self.dtTriggerSubKMP.next();
            });
          }
          if (kmp.kmpDetails[0].RelativeData != undefined) {
            // var table = $('#relationTable').DataTable({ destroy: true });
            // table.destroy();
            // this.relativesArray = kmp.kmpDetails[0].RelativeData;
            // this.dtTriggerRelative.next();
            const self = this;
            this.getRelatives(function (response) {
              self.relativesArray = response.relativesData;
              self.dtTriggerRelative.next();
            });
          }
          this.error = { isError: false, errorMessage: '' }
        }
      })
  }

  setControls() {
     
    this.kmpPersonalForm.controls.IsMarried.setValue('false');
    // this.kmpPersonalForm.controls.Gender.setValue('Male');
    this.kmpPersonalForm.controls.Resident.setValue('false');
    this.kmpContactForm.controls.isAddressSame.setValue('false');
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }


  addKmp() {
    {
      if (this.kmpPersonalForm.status == "VALID") {
         
        var newKmp = {
          "Kmp":
          {
            CompanyID: null,
            FirstName: this.kmpPersonalForm.controls.FirstName.value.trim(),
            MiddleName: this.kmpPersonalForm.controls.MiddleName.value.trim(),
            LastName: this.kmpPersonalForm.controls.LastName.value.trim(),
            FatherFirstName: this.kmpPersonalForm.controls.FatherFirstName.value.trim(),
            FatherMiddleName: this.kmpPersonalForm.controls.FatherMiddleName.value.trim(),
            FatherLastName: this.kmpPersonalForm.controls.FatherLastName.value.trim(),
            MotherFirstName: this.kmpPersonalForm.controls.MotherFirstName.value.trim(),
            MotherMiddleName: this.kmpPersonalForm.controls.MotherMiddleName.value.trim(),
            MotherLastName: this.kmpPersonalForm.controls.MotherLastName.value.trim(),
            DateOfBirth: this.setDate(this.kmpPersonalForm.controls.DateOfBirth.value),
            BirthPlace: this.kmpPersonalForm.controls.BirthPlace.value.trim(),
            Gender: this.kmpPersonalForm.controls.Gender.value,
            Nationality: this.kmpPersonalForm.controls.Nationality.value,
            Resident: this.kmpPersonalForm.controls.Resident.value,
            Occupation: this.kmpPersonalForm.controls.Occupation.value.trim(),
            EducationalQualification: this.kmpPersonalForm.controls.EducationalQualification.value.trim(),
            PAN: this.kmpPersonalForm.controls.PAN.value.toUpperCase(),
            EmailID: this.kmpPersonalForm.controls.EmailID.value,
            IsMarried: this.kmpPersonalForm.controls.IsMarried.value,
            SpouseFirstName: this.kmpPersonalForm.controls.SpouseFirstName.value.trim(),
            SpouseMiddleName: this.kmpPersonalForm.controls.SpouseMiddleName.value.trim(),
            SpouseLastName: this.kmpPersonalForm.controls.SpouseLastName.value.trim(),
            kmpAsDirector: {
              "directorID": this.availableDirectorID,
              "isAvailable": this.directorIsAvailable
            },
          }
        }
        this.KmpMasterService.addKmp(newKmp)
          .subscribe(kmp => {
            if (kmp.status == 0) {
              // localStorage.setItem('KmpID', kmp.kmpdata._id);
              // this.alert.success("KMP details saved successfully.");
              this.alert.successWithOk("KMP details saved successfully.", '/KMP/edit/' + kmp.kmpdata._id);
            }
            else {
              this.alert.error(kmp.message);
            }
          });
      }
    }
  }

  clearKmpPersonalDetails() {
    this.kmpPersonalForm.controls.FirstName.setValue('');
    this.kmpPersonalForm.controls.MiddleName.setValue('');
    this.kmpPersonalForm.controls.LastName.setValue('');
    this.kmpPersonalForm.controls.FatherFirstName.setValue('');
    this.kmpPersonalForm.controls.FatherMiddleName.setValue('');
    this.kmpPersonalForm.controls.FatherLastName.setValue('');
    this.kmpPersonalForm.controls.MotherFirstName.setValue('');
    this.kmpPersonalForm.controls.MotherMiddleName.setValue('');
    this.kmpPersonalForm.controls.MotherLastName.setValue('');
    this.kmpPersonalForm.controls.DateOfBirth.setValue(null);
    this.kmpPersonalForm.controls.BirthPlace.setValue('');
    this.kmpPersonalForm.controls.Nationality.setValue(null);
    this.kmpPersonalForm.controls.EducationalQualification.setValue('');
    this.kmpPersonalForm.controls.PAN.setValue('');
    this.kmpPersonalForm.controls.IsMarried.setValue('false');
    // this.kmpPersonalForm.controls.Gender.setValue('Male');
    this.kmpPersonalForm.controls.Resident.setValue('false');
    this.kmpPersonalForm.controls.SpouseFirstName.setValue('');
    this.kmpPersonalForm.controls.SpouseMiddleName.setValue('');
    this.kmpPersonalForm.controls.SpouseLastName.setValue('');
    this.kmpPersonalForm.controls.Occupation.setValue('');
    this.kmpPersonalForm.controls.EmailID.setValue('');
    $('#personalConfirmation').modal('toggle');
  }

  professionalDetailsInsertUpdate() {
    if (localStorage.getItem('updateKmpId') != undefined && localStorage.getItem('professionalDetailId') != undefined) {
      this.updateProfessionalDetails();
    }
    else {
      this.addProfessional();
    }
  }

  addProfessional() {
     
    var newKmpID = "";
    var directorId = null;
    var otherInstituteVal = "";
    if (localStorage.getItem('KmpID') != undefined) {
      newKmpID = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      newKmpID = localStorage.getItem('updateKmpId');
    }
    if (newKmpID == "") {
      this.alert.error("Please insert Personal Kmp details first.");
      return false;
    }
    if (this.kmpProfessionalForm.controls.Institute.value != "Other") {
      otherInstituteVal = "";
    }
    else {
      otherInstituteVal = this.kmpProfessionalForm.controls.OtherInstitute.value;
    }
    if (this.kmpProfessionalForm.controls.DirectorID.value != '') {
      directorId = this.kmpProfessionalForm.controls.DirectorID.value;
    }
    var newKmp = {
      "KmpProfessionDetails":
      {
        KmpID: newKmpID,
        MembershipNumber: this.kmpProfessionalForm.controls.MembershipNumber.value,
        Din: this.kmpProfessionalForm.controls.Din.value,
        ExpertiseFunctionalAreas: this.kmpProfessionalForm.controls.ExpertiseFunctionalAreas.value,
        FilingMR1Date: this.setDate(this.kmpProfessionalForm.controls.FilingMR1Date.value),
        FillingMR2Date: this.setDate(this.kmpProfessionalForm.controls.FillingMR2Date.value),
        EformDIR12FilingDate: this.setDate(this.kmpProfessionalForm.controls.EformDIR12FilingDate.value),
        Designation: this.kmpProfessionalForm.controls.Designation.value,
        BoardResolutionDate: this.setDate(this.kmpProfessionalForm.controls.BoardResolutionDate.value),
        AppointmentDate: this.setDate(this.kmpProfessionalForm.controls.AppointmentDate.value),
        ReAppointmentDate: this.setDate(this.kmpProfessionalForm.controls.ReAppointmentDate.value),
        CessationDate: this.setDate(this.kmpProfessionalForm.controls.CessationDate.value),
        AppointmentCompletionDate: this.setDate(this.kmpProfessionalForm.controls.AppointmentCompletionDate.value),
        Tenure: this.kmpProfessionalForm.controls.Tenure.value,
        Institute: this.kmpProfessionalForm.controls.Institute.value,
        OtherInstitute: otherInstituteVal,
        OtherDesignation: this.kmpProfessionalForm.controls.OtherDesignation.value,
        DirectorID: directorId
      }
    }
    this.KmpMasterService.addKmp(newKmp)
      .subscribe(kmp => {
        if (kmp.status == 0) {
           
          this.alert.success("KMP Professional details saved successfully.");
        }
        else {
          this.alert.error(kmp.message);
        }
      });
    // }
  }

  updateProfessionalDetails() {
    if (this.kmpProfessionalForm.status == "VALID") {
      var directorId = null;
      var otherInstituteVal = "";
      if (this.kmpProfessionalForm.controls.Institute.value != "Other") {
        otherInstituteVal = "";
      }
      else {
        otherInstituteVal = this.kmpProfessionalForm.controls.OtherInstitute.value;
      }
      if (this.kmpProfessionalForm.controls.DirectorID.value != '') {
        directorId = this.kmpProfessionalForm.controls.DirectorID.value;
      }
       
      var updateProfessionalDetails = {
        "KmpProfessionDetails":
        {
          _id: localStorage.getItem('professionalDetailId'),
          MembershipNumber: this.kmpProfessionalForm.controls.MembershipNumber.value,
          Din: this.kmpProfessionalForm.controls.Din.value,
          KmpID: localStorage.getItem('updateKmpId'),
          ExpertiseFunctionalAreas: this.kmpProfessionalForm.controls.ExpertiseFunctionalAreas.value,
          FilingMR1Date: this.setDate(this.kmpProfessionalForm.controls.FilingMR1Date.value),
          FillingMR2Date: this.setDate(this.kmpProfessionalForm.controls.FillingMR2Date.value),
          EformDIR12FilingDate: this.setDate(this.kmpProfessionalForm.controls.EformDIR12FilingDate.value),
          Designation: this.kmpProfessionalForm.controls.Designation.value,
          BoardResolutionDate: this.setDate(this.kmpProfessionalForm.controls.BoardResolutionDate.value),
          AppointmentDate: this.setDate(this.kmpProfessionalForm.controls.AppointmentDate.value),
          ReAppointmentDate: this.setDate(this.kmpProfessionalForm.controls.ReAppointmentDate.value),
          CessationDate: this.setDate(this.kmpProfessionalForm.controls.CessationDate.value),
          AppointmentCompletionDate: this.setDate(this.kmpProfessionalForm.controls.AppointmentCompletionDate.value),
          Tenure: this.kmpProfessionalForm.controls.Tenure.value,
          Institute: this.kmpProfessionalForm.controls.Institute.value,
          OtherDesignation: this.kmpProfessionalForm.controls.OtherDesignation.value,
          OtherInstitute: otherInstituteVal,
          DirectorID: directorId,
          ModifiedBy: null,
          ModifiedDate: null
        }
      }
      this.KmpMasterService.addKmp(updateProfessionalDetails)
        .subscribe(kmp => {
          if (kmp.status == 0) {
             
            this.alert.success("KMP professional details updated successfully.");
          }
          else {
            this.alert.error(kmp.message);
          }
        });
    }
  }

  clearProfessionalDetails() {
    this.kmpProfessionalForm.controls.Din.setValue('');
    this.kmpProfessionalForm.controls.Designation.setValue('');
    this.kmpProfessionalForm.controls.ExpertiseFunctionalAreas.setValue('');
    this.kmpProfessionalForm.controls.BoardResolutionDate.setValue(null);
    this.kmpProfessionalForm.controls.AppointmentDate.setValue(null);
    this.kmpProfessionalForm.controls.EformDIR12FilingDate.setValue(null);
    this.kmpProfessionalForm.controls.FilingMR1Date.setValue(null);
    this.kmpProfessionalForm.controls.ReAppointmentDate.setValue(null);
    this.kmpProfessionalForm.controls.FillingMR2Date.setValue(null);
    this.kmpProfessionalForm.controls.Tenure.setValue('');
    this.kmpProfessionalForm.controls.AppointmentCompletionDate.setValue(null);
    this.kmpProfessionalForm.controls.CessationDate.setValue(null);
    this.kmpProfessionalForm.controls.MembershipNumber.setValue('');
    this.kmpProfessionalForm.controls.Institute.setValue(null);
    $('#professionalConfirmation').modal('toggle');
  }

  addContact() {
    if (this.kmpContactForm.status == "VALID") {
       
      var newKmpID = "";
      if (localStorage.getItem('KmpID') != undefined) {
        newKmpID = localStorage.getItem('KmpID');
      }
      else if (localStorage.getItem('updateKmpId') != undefined) {
        newKmpID = localStorage.getItem('updateKmpId');
      }
      if (newKmpID == "") {
        this.alert.error("Please insert Personal Kmp details first.");
        return false;
      }
      var newKmp = {
        "KmpContactDetails":
        {
          KmpID: newKmpID,
          PermenantResidentialAddress: {
            PinCode: this.PermenantResidentialAddress.controls.PinCode.value.trim(),
            City: this.PermenantResidentialAddress.controls.City.value.trim(),
            State: this.PermenantResidentialAddress.controls.State.value,
            Country: this.PermenantResidentialAddress.controls.Country.value,
            Line2: this.PermenantResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PermenantResidentialAddress.controls.Line1.value.trim()
          },
          PresentResidentialAddress: {
            PinCode: this.PresentResidentialAddress.controls.PinCode.value.trim(),
            City: this.PresentResidentialAddress.controls.City.value.trim(),
            State: this.PresentResidentialAddress.controls.State.value,
            Country: this.PresentResidentialAddress.controls.Country.value,
            Line2: this.PresentResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PresentResidentialAddress.controls.Line1.value.trim()
          },
          OfficeAddress: {
            PinCode: this.OfficeAddress.controls.PinCode.value.trim(),
            City: this.OfficeAddress.controls.City.value.trim(),
            State: this.OfficeAddress.controls.State.value,
            Country: this.OfficeAddress.controls.Country.value,
            Line2: this.OfficeAddress.controls.Line2.value.trim(),
            Line1: this.OfficeAddress.controls.Line1.value.trim()
          },
          OfficeTelephoneNumber: this.kmpContactForm.controls.OfficeTelephoneNumber.value,
          ResidentTelephoneNumber: this.kmpContactForm.controls.ResidentTelephoneNumber.value,
          Fax: this.kmpContactForm.controls.Fax.value,
          MobileNumber: this.kmpContactForm.controls.MobileNumber.value,
          AadhaarNumber: this.kmpContactForm.controls.AadhaarNumber.value.trim(),
          IdentityNumber: this.kmpContactForm.controls.IdentityNumber.value.trim(),
          PassportNumber: this.kmpContactForm.controls.PassportNumber.value.trim(),
          DrivingLicenseNumber: this.kmpContactForm.controls.DrivingLicenseNumber.value.trim()
        }
      }
      this.KmpMasterService.addKmp(newKmp)
        .subscribe(kmp => {
          if (kmp.status == 0) {
             
            this.alert.success("KMP contact details saved successfully.");
          }
          else {
            this.alert.error(kmp.message);
          }
        });
    }
  }

  updateContactDetails() {
    if (this.kmpContactForm.status == "VALID") {
       //professionalDetailId
      var updateContactDetails = {
        "KmpContactDetails":
        {
          _id: localStorage.getItem('contactDetailId'),
          KmpID: localStorage.getItem('updateKmpId'),
          PermenantResidentialAddress: {
            PinCode: this.PermenantResidentialAddress.controls.PinCode.value.trim(),
            City: this.PermenantResidentialAddress.controls.City.value.trim(),
            State: this.PermenantResidentialAddress.controls.State.value,
            Country: this.PermenantResidentialAddress.controls.Country.value,
            Line2: this.PermenantResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PermenantResidentialAddress.controls.Line1.value.trim()
          },
          PresentResidentialAddress: {
            PinCode: this.PresentResidentialAddress.controls.PinCode.value.trim(),
            City: this.PresentResidentialAddress.controls.City.value.trim(),
            State: this.PresentResidentialAddress.controls.State.value,
            Country: this.PresentResidentialAddress.controls.Country.value,
            Line2: this.PresentResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PresentResidentialAddress.controls.Line1.value.trim()
          },
          OfficeAddress: {
            PinCode: this.OfficeAddress.controls.PinCode.value.trim(),
            City: this.OfficeAddress.controls.City.value.trim(),
            State: this.OfficeAddress.controls.State.value,
            Country: this.OfficeAddress.controls.Country.value,
            Line2: this.OfficeAddress.controls.Line2.value.trim(),
            Line1: this.OfficeAddress.controls.Line1.value.trim()
          },
          OfficeTelephoneNumber: this.kmpContactForm.controls.OfficeTelephoneNumber.value,
          ResidentTelephoneNumber: this.kmpContactForm.controls.ResidentTelephoneNumber.value,
          Fax: this.kmpContactForm.controls.Fax.value,
          MobileNumber: this.kmpContactForm.controls.MobileNumber.value,
          AadhaarNumber: this.kmpContactForm.controls.AadhaarNumber.value.trim(),
          IdentityNumber: this.kmpContactForm.controls.IdentityNumber.value.trim(),
          PassportNumber: this.kmpContactForm.controls.PassportNumber.value.trim(),
          DrivingLicenseNumber: this.kmpContactForm.controls.DrivingLicenseNumber.value.trim(),
          ModifiedBy: null,
          ModifiedDate: null
        }
      }
      this.KmpMasterService.addKmp(updateContactDetails)
        .subscribe(kmpContact => {
          if (kmpContact.status == 0) {
             
            this.alert.success("KMP contact details updated successfully.");
          }
          else {
            this.alert.error(kmpContact.message);
          }
        });
    }
  }

  contactdetailsInsertUpdate() {
    if (localStorage.getItem('updateKmpId') != undefined && localStorage.getItem('contactDetailId') != undefined) {
      this.updateContactDetails();
    }
    else {
      this.addContact();
    }
  }

  clearContactDetails() {
    this.PermenantResidentialAddress.controls.Line1.setValue('');
    this.PermenantResidentialAddress.controls.Line2.setValue('');
    this.PermenantResidentialAddress.controls.Country.setValue(null);
    this.PermenantResidentialAddress.controls.State.setValue(null);
    this.PermenantResidentialAddress.controls.PinCode.setValue('');
    this.PermenantResidentialAddress.controls.City.setValue('');
    this.PresentResidentialAddress.controls.Line1.setValue('');
    this.PresentResidentialAddress.controls.Line2.setValue('');
    this.PresentResidentialAddress.controls.Country.setValue(null);
    this.PresentResidentialAddress.controls.State.setValue(null);
    this.PresentResidentialAddress.controls.City.setValue('');
    this.PresentResidentialAddress.controls.PinCode.setValue('');
    this.OfficeAddress.controls.Line1.setValue('');
    this.OfficeAddress.controls.Line2.setValue('');
    this.OfficeAddress.controls.PinCode.setValue('');
    this.OfficeAddress.controls.City.setValue('');
    this.OfficeAddress.controls.Country.setValue(null);
    this.OfficeAddress.controls.State.setValue(null);
    this.kmpContactForm.controls.OfficeTelephoneNumber.setValue('');
    this.kmpContactForm.controls.ResidentTelephoneNumber.setValue('');
    this.kmpContactForm.controls.Fax.setValue('');
    this.kmpContactForm.controls.AadhaarNumber.setValue('');
    this.kmpContactForm.controls.IdentityNumber.setValue('');
    this.kmpContactForm.controls.PassportNumber.setValue('');
    this.kmpContactForm.controls.MobileNumber.setValue('');
    this.kmpContactForm.controls.DrivingLicenseNumber.setValue('');
    $("#contactConfirmation").modal('toggle');
  }

  addKmpship() {
    if (this.kmpshipForm.status == "VALID") {
       
      var newKmpID = "";
      if (localStorage.getItem('KmpID') != undefined) {
        newKmpID = localStorage.getItem('KmpID');
      }
      else if (localStorage.getItem('updateKmpId') != undefined) {
        newKmpID = localStorage.getItem('updateKmpId');
      }
      if (newKmpID == "") {
        $('#kmpshipDialog').modal('toggle');
        this.alert.error("Please insert Personal kmp details first.");
        return false;
      }
      var newkmpship = {
        "Kmpship": {
          KmpID: newKmpID,
          OfficeName: this.kmpshipForm.controls.OfficeName.value,
          OfficeType: this.kmpshipForm.controls.OfficeType.value,
          CIN: this.kmpshipForm.controls.CIN.value,
          AppointmentDate: this.setDate(this.kmpshipForm.controls.AppointmentDate.value),
          Designation: this.kmpshipForm.controls.Designation.value,
          CessationDate: this.setDate(this.kmpshipForm.controls.CessationDate.value),
          // IsSection8: this.kmpshipForm.controls.IsSection8.value,
          NatureOfIntrest: this.kmpshipForm.controls.NatureOfIntrest.value,
          PAN: this.kmpshipForm.controls.PAN.value,
          ShareHolding: this.kmpshipForm.controls.ShareHolding.value,
          DormantCompany: this.kmpshipForm.controls.DormantCompany.value,
          OtherCompany: this.kmpshipForm.controls.OtherCompany.value,
          OtherDesignation: this.kmpshipForm.controls.OtherDesignation.value,
          OtherNatureOfInterest: this.kmpshipForm.controls.OtherNatureOfInterest.value,
          CommitteeType: this.kmpshipForm.controls.CommitteeType.value,
          OtherCommittee: this.kmpshipForm.controls.OtherCommittee.value
        }
      }
      this.KmpMasterService.addKmp(newkmpship)
        .subscribe(kmpship => {
          if (kmpship.status == 0) {
             
            $('#kmpshipDialog').modal('toggle');
            this.alert.success("KMP details saved successfully.");
            this.loadKmpshipDetails(newKmpID);
            this.clearKmpship();
          }
          else {
            $('#kmpshipDialog').modal('toggle');
            this.alert.error(kmpship.message);
          }
        });
    }
  }

  addSubKmp() {
    if (this.subKmpForm.status == "VALID") {
       
      var newkmpID = "";
      if (localStorage.getItem('KmpID') != undefined) {
        newkmpID = localStorage.getItem('KmpID');
      }
      else if (localStorage.getItem('updateKmpId') != undefined) {
        newkmpID = localStorage.getItem('updateKmpId');
      }
      if (newkmpID == "") {
        $("#subkmpDialog").modal('toggle');
        this.alert.error("Please insert Personal Kmp details first.");
        return false;
      }
      var SubKmp = {
        "SubKmp": {
          KmpID: newkmpID,
          CompanyName: this.subKmpForm.controls.CompanyName.value,
          NumberOfSecurities: this.subKmpForm.controls.NumberOfSecurities.value,
          SecurityDescription: this.subKmpForm.controls.SecurityDescription.value,
          SecurityNominalValue: this.subKmpForm.controls.SecurityNominalValue.value,
          AcquisitionDate: this.setDate(this.subKmpForm.controls.AcquisitionDate.value),
          AcquisitionPaidPrize: this.subKmpForm.controls.AcquisitionPaidPrize.value,
          AcquisitionOtherPrize: this.subKmpForm.controls.AcquisitionOtherPrize.value,
          DisposalDate: this.setDate(this.subKmpForm.controls.DisposalDate.value),
          NumberOfSharesDisposed: this.subKmpForm.controls.NumberOfSharesDisposed.value,
          DisposalPrize: this.subKmpForm.controls.DisposalPrize.value,
          DisposalReceivedPrize: this.subKmpForm.controls.DisposalReceivedPrize.value,
          CumulativePrize: this.subKmpForm.controls.CumulativePrize.value,
          AcquisitionSecuritiesMode: this.subKmpForm.controls.AcquisitionSecuritiesMode.value,
          HoldingMode: this.subKmpForm.controls.HoldingMode.value,
          PledgedSecurities: this.subKmpForm.controls.PledgedSecurities.value,
          Shareholding: this.subKmpForm.controls.Shareholding.value,
          IsActive: true,
          IsAuthorize: false,
          IsRectify: false,
          ModifiedBy: null,
          ModifiedDate: new Date()
        }
      }
      this.KmpMasterService.addKmp(SubKmp)
        .subscribe(subkmp => {
          if (subkmp.status == 0) {
             
            $("#subkmpDialog").modal('toggle');
            this.alert.success("Sub KMP details saved successfully.");
            this.loadsubkmpDetails(newkmpID);
            this.clearSubKmp();
          }
          else {
            $("#subkmpDialog").modal('toggle');
            this.alert.error(subkmp.message);
          }
        });
    }
  }

  updateKmp() {
    if (this.kmpPersonalForm.status == "VALID") {
       
      var updateKmp = {
        "Kmp":
        {
          _id: localStorage.getItem('updateKmpId'),
          CompanyID: null,
          FirstName: this.kmpPersonalForm.controls.FirstName.value.trim(),
          MiddleName: this.kmpPersonalForm.controls.MiddleName.value.trim(),
          LastName: this.kmpPersonalForm.controls.LastName.value.trim(),
          FatherFirstName: this.kmpPersonalForm.controls.FatherFirstName.value.trim(),
          FatherMiddleName: this.kmpPersonalForm.controls.FatherMiddleName.value.trim(),
          FatherLastName: this.kmpPersonalForm.controls.FatherLastName.value.trim(),
          MotherFirstName: this.kmpPersonalForm.controls.MotherFirstName.value.trim(),
          MotherMiddleName: this.kmpPersonalForm.controls.MotherMiddleName.value.trim(),
          MotherLastName: this.kmpPersonalForm.controls.MotherLastName.value.trim(),
          DateOfBirth: this.setDate(this.kmpPersonalForm.controls.DateOfBirth.value),
          BirthPlace: this.kmpPersonalForm.controls.BirthPlace.value.trim(),
          Gender: this.kmpPersonalForm.controls.Gender.value,
          Nationality: this.kmpPersonalForm.controls.Nationality.value,
          Resident: this.kmpPersonalForm.controls.Resident.value,
          Occupation: this.kmpPersonalForm.controls.Occupation.value.trim(),
          EducationalQualification: this.kmpPersonalForm.controls.EducationalQualification.value.trim(),
          EmailID: this.kmpPersonalForm.controls.EmailID.value,
          PAN: this.kmpPersonalForm.controls.PAN.value.toUpperCase(),
          IsMarried: this.kmpPersonalForm.controls.IsMarried.value,
          SpouseFirstName: this.kmpPersonalForm.controls.SpouseFirstName.value.trim(),
          SpouseMiddleName: this.kmpPersonalForm.controls.SpouseMiddleName.value.trim(),
          SpouseLastName: this.kmpPersonalForm.controls.SpouseLastName.value.trim(),
          kmpAsDirector: {
            "directorID": this.availableDirectorID,
            "isAvailable": this.directorIsAvailable
          },
          ModifiedBy: null,
          ModifiedDate: null
        }
      }
      this.KmpMasterService.addKmp(updateKmp)
        .subscribe(kmp => {
          if (kmp.status == 0) {
             
            this.alert.success("KMP details updated successfully.");
          }
          else {
            this.alert.error(kmp.message);
          }
        });
    }
  }

  InsertAndUpdateRelatives() {
     
    this.showOtherCompanyForRelative = false;
    this.showShareholdingInRelative = false;
    this.showOtherNatureForRelative = false;
    if (this.globalRelativeID != undefined) {
      this.updateRelatives();
    }
    else {
      this.addRelatives();
    }
  }

  addRelatives() {
    if (this.relativeForm.status == "VALID") {
       
      var newkmpID = "";
      if (localStorage.getItem('KmpID') != undefined) {
        newkmpID = localStorage.getItem('KmpID');
      }
      else if (localStorage.getItem('updateKmpId') != undefined) {
        newkmpID = localStorage.getItem('updateKmpId');
      }
      //check 
      var relativeData = {
        "addRelative":
        {
          CompanyID: null,
          KmpID: newkmpID,
          RelativeName: this.relativeForm.controls.RelativeName.value.trim(),
          Relationship: this.relativeForm.controls.Relationship.value,
          RelativePAN: this.relativeForm.controls.RelativePAN.value,
          FirmName: this.relativeForm.controls.FirmName.value.trim(),
          CompanyPAN: this.relativeForm.controls.CompanyPAN.value.trim(),
          FirmType: this.relativeForm.controls.FirmType.value,
          NatureOfIntrest: this.relativeForm.controls.NatureOfIntrest.value,
          IntrestDate: this.setDate(this.relativeForm.controls.IntrestDate.value),
          IntrestChange: this.relativeForm.controls.IntrestChange.value,
          IntrestChangeDate: this.setDate(this.relativeForm.controls.IntrestChangeDate.value),
          Shareholding: this.relativeForm.controls.Shareholding.value,
          OtherCompanyForRelative: this.relativeForm.controls.OtherCompanyForRelative.value,
          OtherNatureOfIntrestForRelative: this.relativeForm.controls.OtherNatureOfIntrestForRelative.value,
          CommitteeType: this.relativeForm.controls.CommitteeType.value,
          OtherCommittee: this.relativeForm.controls.OtherCommittee.value,
          Status: true,
          DormantCompany: this.relativeForm.controls.DormantCompany.value,
          CIN: this.relativeForm.controls.CIN.value,
        }
      }
      this.KmpMasterService.addRelatives(relativeData)
        .subscribe((relatives:any) => {
          if (relatives.status == 0) {
             
            $('#relativeDialog').modal('toggle');
            this.loadRelativesDetails(newkmpID);
            // this.getRelativeByParam();
            this.alert.success("Relative details saved successfully.");
            this.clearRelatives();
          }
          else {
            $('#relativeDialog').modal('toggle');
            this.alert.error(relatives.message);
            this.clearRelatives();
          }
        });
    }
  }

  clearRelatives() {
     
    this.relativeForm.controls.RelativeName.setValue('');
    this.relativeForm.controls.RelativePAN.setValue('');
    this.relativeForm.controls.FirmName.setValue('');
    this.relativeForm.controls.CompanyPAN.setValue('');
    this.relativeForm.controls.IntrestChange.setValue('');
    this.relativeForm.controls.Shareholding.setValue('');
    this.relativeForm.controls.Relationship.setValue('');
    this.relativeForm.controls.NatureOfIntrest.setValue(null);
    this.relativeForm.controls.IntrestDate.setValue(null);
    this.relativeForm.controls.FirmType.setValue(null);
    this.relativeForm.controls.IntrestChangeDate.setValue(null);
    this.relativeForm.controls.CommitteeType.setValue(null);
    this.relativeForm.controls.OtherCommittee.setValue(null);
    this.showShareholdingInRelative = false
    this.showOtherCompanyForRelative = false
    this.showCommiteeRelative = false
    this.showOtherCommiteeRelative = false
    this.showOtherNatureForRelative = false
  }

  PersonalDetailsInsertUpdate() {
    if (localStorage.getItem('updateKmpId') != undefined) {
      this.updateKmp();
    }
    else {
      this.addKmp();
    }
  }

  openAddRelativeModal() {
    this.getNatureOfInterestInDisclosureOfIntrest();
    this.globalRelativeID = undefined;
    $('#myModalRelativeDetailsLabel').html("<i class='fa fa-plus'></i>Add Relatives' Details");
    $("#btnSaveUpdateRelative").html('<i class="fa fa-save"></i>Save');
    this.relativeForm.controls['IntrestChangeDate'].disable();
  }

  fetchRelatives(i) {
     
    console.log('relative Details-->>', this.relativesArray[i]);
    $('#myModalRelativeDetailsLabel').html("<i class='fa fa-pencil'></i>Edit Relatives' Details");
    $("#btnSaveUpdateRelative").html('<i class="fa fa-save"></i>Update');
    let dt;
    //localStorage.setItem('relativeId', this.relativesArray[i]._id);
    this.globalRelativeID = this.relativesArray[i]._id;
    this.relativeForm.controls.RelativeName.setValue(this.relativesArray[i].RelativeName);
    this.relativeForm.controls.Relationship.setValue(this.relativesArray[i].Relationship);
    this.relativeForm.controls.RelativePAN.setValue(this.relativesArray[i].RelativePAN);
    this.relativeForm.controls.FirmName.setValue(this.relativesArray[i].FirmName);
    this.relativeForm.controls.CompanyPAN.setValue(this.relativesArray[i].CompanyPAN);

    if (this.relativesArray[i].FirmType != null) {
      this.relativeForm.controls.FirmType.setValue(this.relativesArray[i].FirmType);
    }
    else {
      this.relativeForm.controls.FirmType.setValue(null);
    }
    if (this.relativesArray[i].FirmType == "Others") {
      this.showOtherCompanyForRelative = true;
      this.relativeForm.controls.OtherCompanyForRelative.setValue(this.relativesArray[i].OtherCompanyForRelative);
    }
    else {
      this.showOtherCompanyForRelative = false;
      this.relativeForm.controls.OtherCompanyForRelative.setValue(null);
    }
    if (this.relativesArray[i].NatureOfIntrest != null) {
      this.relativeForm.controls.NatureOfIntrest.setValue(this.relativesArray[i].NatureOfIntrest);
    }
    else {
      this.relativeForm.controls.NatureOfIntrest.setValue(null);
    }
    console.log('this.relativesArray[i].DormantCompany',this.relativesArray[i])
    if (this.relativesArray[i].FirmType == "Private Limited Company" || this.relativesArray[i].FirmType == "OPC" || this.relativesArray[i].FirmType == "Public Unlisted Company") {
      this.showDormantStateRelative = true;
      this.relativeForm.controls.DormantCompany.setValue('true');
    }
    else {
      this.showDormantStateRelative = false;
      this.relativeForm.controls.DormantCompany.setValue('false');
    }

    if (this.relativesArray[i].FirmType == "Private Debt Listed Company" || this.relativesArray[i].FirmType == "Private Limited Company" || this.relativesArray[i].FirmType == "Public Listed Company"
      || this.relativesArray[i].FirmType == "Public Unlisted Company" || this.relativesArray[i].FirmType == "Section 8 Company" || this.relativesArray[i].FirmType == "OPC"
      || this.relativesArray[i].FirmType == "Foreign Company") {
      this.showCINRelative = true;
      this.relativeForm.controls.CIN.setValue(this.relativesArray[i].CIN);
    }
    else {
      this.showCINRelative = false;
      this.relativeForm.controls.CIN.setValue(null);
    }

    if (this.relativesArray[i].FirmType != null) {
      var event = {
        target: {
          value: this.relativesArray[i].FirmType
        }
      };    
      this.setNatureOfIntrest(event);
    }

    if (this.relativesArray[i].IntrestDate != null) {
      dt = new Date(this.setFormatDate(this.relativesArray[i].IntrestDate));
      this.IntrestDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    this.relativeForm.controls.IntrestChange.setValue(this.relativesArray[i].IntrestChange);
    if (this.relativesArray[i].IntrestChangeDate != null) {
      dt = new Date(this.setFormatDate(this.relativesArray[i].IntrestChangeDate));
      this.IntrestChangeDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    //this.relativeForm.controls.Shareholding.setValue(this.relativesArray[i].Shareholding);
    if (this.relativesArray[i].NatureOfIntrest == "Member") {
      this.showShareholdingInRelative = true;
      this.relativeForm.controls.Shareholding.setValue(this.relativesArray[i].Shareholding);
    }
    else {
      this.showShareholdingInRelative = false;
      this.relativeForm.controls.Shareholding.setValue(null);
    }
    if (this.relativesArray[i].NatureOfIntrest == "Others") {
      this.showOtherNatureForRelative = true;
      this.relativeForm.controls.OtherNatureOfIntrestForRelative.setValue(this.relativesArray[i].OtherNatureOfIntrestForRelative);
    }
    else {
      this.showOtherNatureForRelative = false;
      this.relativeForm.controls.OtherNatureOfIntrestForRelative.setValue(null);
    }




    // if (this.relativesArray[i].NatureOfIntrest == "Committee Member" || this.relativesArray[i].NatureOfIntrest == "Committee Chairman") {
    //   this.showCommiteeRelative = true;
    //   this.relativeForm.controls.CommitteeType.setValue(this.relativesArray[i].CommitteeType);
    // }
    // else {
    //   this.showCommiteeRelative = false;
    //   this.relativeForm.controls.CommitteeType.setValue(null);
    // }

    // if (this.relativesArray[i].CommitteeType == "Others") {
    //   this.showOtherCommiteeRelative = true;
    //   this.relativeForm.controls.OtherCommittee.setValue(this.relativesArray[i].OtherCommittee);
    // }
    // else {
    //   this.showOtherCommiteeRelative = false;
    //   this.relativeForm.controls.OtherCommittee.setValue(null);
    // }
    this.committeeArray = DataArray.Committee;

    this.relativeForm.controls.CommitteeType.setValue(this.relativesArray[i].CommitteeType);
    this.relativeForm.controls.OtherCommittee.setValue(this.relativesArray[i].OtherCommittee);
    if (this.relativesArray[i].NatureOfIntrest == "Committee Member" || this.relativesArray[i].NatureOfIntrest == "Committee Chairman") {
      this.showCommiteeRelative = true;
      this.showOtherCommiteeRelative = false;
      if (this.relativesArray[i].CommitteeType == "Others") {
        this.showOtherCommiteeRelative = true;
      }
      else {
        this.showOtherCommiteeRelative = false;
      }
    }
    else {
      this.showCommiteeRelative = false;
      this.showOtherCommiteeRelative = false;
    }


    $('#relativeDialog').modal('toggle');
    // this.saveRelativeButton = true;
    // this.updateRelativeButton = false;
  }

  onlyTwoDecimal(ev) {
    $('.dacimalFix').on('input', function () {
      this.value = this.value.replace(/(\.[\d]{2})./g, '$1'); // not more than 2 digits after decimal
    });
  }

  updateRelatives() {
     
    var newkmpID = "";
    if (localStorage.getItem('KmpID') != undefined) {
      newkmpID = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      newkmpID = localStorage.getItem('updateKmpId');
    }
    var relativeData = {
      "addRelative":
      {
        _id: this.globalRelativeID,
        KmpID: newkmpID,
        CompanyID: null,
        RelativeName: this.relativeForm.controls.RelativeName.value.trim(),
        Relationship: this.relativeForm.controls.Relationship.value,
        RelativePAN: this.relativeForm.controls.RelativePAN.value.toUpperCase(),
        FirmName: this.relativeForm.controls.FirmName.value.trim(),
        CompanyPAN: this.relativeForm.controls.CompanyPAN.value.trim(),
        FirmType: this.relativeForm.controls.FirmType.value,
        NatureOfIntrest: this.relativeForm.controls.NatureOfIntrest.value,
        IntrestDate: this.setDate(this.relativeForm.controls.IntrestDate.value),
        IntrestChange: this.relativeForm.controls.IntrestChange.value,
        IntrestChangeDate: this.setDate(this.relativeForm.controls.IntrestChangeDate.value),
        Shareholding: this.relativeForm.controls.Shareholding.value,
        OtherCompanyForRelative: this.relativeForm.controls.OtherCompanyForRelative.value,
        OtherNatureOfIntrestForRelative: this.relativeForm.controls.OtherNatureOfIntrestForRelative.value,
        CommitteeType: this.relativeForm.controls.CommitteeType.value,
        OtherCommittee: this.relativeForm.controls.OtherCommittee.value,
        Status: true,
        DormantCompany: this.relativeForm.controls.DormantCompany.value,
        CIN: this.relativeForm.controls.CIN.value,
      }
    }
    this.KmpMasterService.addRelatives(relativeData)
      .subscribe((relativeUpdate:any) => {
        if (relativeUpdate.status == 0) {
           
          $('#relativeDialog').modal('toggle');
          // this.loadRelativesDetails(newkmpID);
          this.relativesArray = [];
          $("#relationTable").DataTable().destroy();
          this.getRelativeByParam();
          this.alert.success("Relative updated successfully.");
          this.clearRelatives();
          localStorage.removeItem('relativeId');

        }
        else {
          $('#relativeDialog').modal('toggle');
          this.alert.error(relativeUpdate.message);
          this.clearRelatives();
        }
      });
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 11) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }

  }

  onlyNumberWithoutDecimal(ev) {
     ;
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  DinNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 8 digits
      if ((ev.target.value + ev.key).length > 8) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  get PermenantResidentialAddress(): any { return this.kmpContactForm.get('PermenantResidentialAddress'); }
  get PresentResidentialAddress(): any { return this.kmpContactForm.get('PresentResidentialAddress'); }
  get OfficeAddress(): any { return this.kmpContactForm.get('OfficeAddress'); }

  presentaddressIssame() {
    this.PresentResidentialAddress.controls.Line1.setValue(this.PermenantResidentialAddress.controls.Line1.value);
    this.PresentResidentialAddress.controls.Line2.setValue(this.PermenantResidentialAddress.controls.Line2.value);
    this.PresentResidentialAddress.controls.City.setValue(this.PermenantResidentialAddress.controls.City.value);
    this.PresentResidentialAddress.controls.PinCode.setValue(this.PermenantResidentialAddress.controls.PinCode.value);
    this.PresentResidentialAddress.controls.Country.setValue(this.PermenantResidentialAddress.controls.Country.value);
    this.PresentResidentialAddress.controls.State.setValue(this.PermenantResidentialAddress.controls.State.value);

  }

  permenantaddressIsnotsame() {
    this.PresentResidentialAddress.controls.Line1.setValue('');
    this.PresentResidentialAddress.controls.Line2.setValue('');
    this.PresentResidentialAddress.controls.Country.setValue(null);
    this.PresentResidentialAddress.controls.State.setValue(null);
    this.PresentResidentialAddress.controls.City.setValue('');
    this.PresentResidentialAddress.controls.PinCode.setValue('');
  }

  openOfficeHeldOrRelinquishedModal() {
    this.getNatureOfInterestInDisclosureOfIntrest();
    this.globalKmpshipID = undefined;
    $('#myModalOfficeHeldOrRelinquishedLabel').html('<i class="fa fa-plus"></i>Add Office of KMP held or relinquished in any other body corporate :');
    $("#btnSaveUpdateKmpship").html('<i class="fa fa-save"></i>Save');
    this.kmpshipForm.controls['CessationDate'].disable();
  }

  fetchKmpshipRow(i) {
    this.committeeArray = DataArray.Committee;
    this.showCommitee = false;
    this.showOtherCommitee = false;
    let dt;
    $('#myModalOfficeHeldOrRelinquishedLabel').html('<i class="fa fa-pencil"></i>Edit Office of KMP held or relinquished in any other body corporate :');
    $("#btnSaveUpdateKmpship").html('<i class="fa fa-save"></i>Update');
    // localStorage.setItem('kmpshipId', this.kmpshipArray[i]._id);
    this.globalKmpshipID = this.kmpshipArray[i]._id;
    this.kmpshipForm.controls.OfficeName.setValue(this.kmpshipArray[i].OfficeName);
    this.kmpshipForm.controls.CIN.setValue(this.kmpshipArray[i].CIN);
    this.kmpshipForm.controls.OfficeType.setValue(this.kmpshipArray[i].OfficeType);

    if (this.kmpshipArray[i].OfficeType != null) {
      var event = {
        target: {
          value: this.kmpshipArray[i].OfficeType
        }
      };
      this.setdormantCompany(event);
      this.setCIN(event);
      this.setOtherCompany(event);
      this.setNatureOfIntrest(event);
    }

    this.kmpshipForm.controls.Designation.setValue(this.kmpshipArray[i].Designation);

    if (this.kmpshipArray[i].AppointmentDate != null) {
      dt = new Date(this.setFormatDate(this.kmpshipArray[i].AppointmentDate));
      this.dirAppointmentDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    if (this.kmpshipArray[i].CessationDate != null) {
      dt = new Date(this.setFormatDate(this.kmpshipArray[i].CessationDate));
      this.dirCessationDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    if (this.kmpshipArray[i].Designation == "Others") {
      this.showOtherCompany = true;
      this.kmpshipForm.controls.OtherDesignation.setValue(this.kmpshipArray[i].OtherDesignation);
    }
    else {
      this.showOtherCompany = false;
      this.kmpshipForm.controls.OtherDesignation.setValue(null);
    }
    this.kmpshipForm.controls.PAN.setValue(this.kmpshipArray[i].PAN);
    if (this.kmpshipArray[i].OfficeType == "OPC" || this.kmpshipArray[i].OfficeType == "Public Unlisted Company" || this.kmpshipArray[i].OfficeType == "Private Limited Company") {
      this.showDormantState = true;
      if (this.kmpshipArray[i].DormantCompany != null && this.kmpshipArray[i].DormantCompany == true) {
        this.kmpshipForm.controls.DormantCompany.setValue('true');
      }
      else {
        this.kmpshipForm.controls.DormantCompany.setValue('false');
      }
    }
    else {
      this.showDormantState = false;
    }
    if (this.kmpshipArray[i].OfficeType == "Others") {
      this.showOtherCompany = true;
      this.kmpshipForm.controls.OtherCompany.setValue(this.kmpshipArray[i].OtherCompany);
    }
    else {
      this.showOtherCompany = false;
      this.kmpshipForm.controls.OtherCompany.setValue(null);
    }
    if (this.kmpshipArray[i].OfficeType == "Private Debt Listed Company" || this.kmpshipArray[i].OfficeType == "Private Limited Company"
      || this.kmpshipArray[i].OfficeType == "Public Listed Company" || this.kmpshipArray[i].OfficeType == "Public Unlisted Company" || this.kmpshipArray[i].OfficeType == "Section 8 Company" ||
      this.kmpshipArray[i].OfficeType == "OPC" || this.kmpshipArray[i].OfficeType == "Foreign Company") {
      this.showCIN = true;
      this.kmpshipForm.controls.CIN.setValue(this.kmpshipArray[i].CIN);
    }
    else {
      this.showCIN = false;
      this.kmpshipForm.controls.CIN.setValue(null);
    }
    this.kmpshipForm.controls.NatureOfIntrest.setValue(this.kmpshipArray[i].NatureOfIntrest);
    if (this.kmpshipArray[i].NatureOfIntrest == "Others") {
      this.showOtherNatureOfInterest = true;
      this.kmpshipForm.controls.OtherNatureOfInterest.setValue(this.kmpshipArray[i].OtherNatureOfInterest);
    }
    else {
      this.showOtherNatureOfInterest = false;
      this.kmpshipForm.controls.OtherNatureOfInterest.setValue(null);
    }
    if (this.kmpshipArray[i].NatureOfIntrest == "Member") {
      this.showShareHolding = true;
      this.kmpshipForm.controls.ShareHolding.setValue(this.kmpshipArray[i].ShareHolding);
    }
    else {
      this.showShareHolding = false;
      this.kmpshipForm.controls.ShareHolding.setValue(null);
    }
    if (this.kmpshipArray[i].NatureOfIntrest == "Committee Member" || this.kmpshipArray[i].NatureOfIntrest == "Committee Chairman") {
      this.showCommitee = true;
      this.showOtherCommitee = false;
      this.kmpshipForm.controls.CommitteeType.setValue(this.kmpshipArray[i].CommitteeType);
      if (this.kmpshipArray[i].CommitteeType == "Others") {
        this.showOtherCommitee = true;
        this.kmpshipForm.controls.OtherCommittee.setValue(this.kmpshipArray[i].OtherCommittee);
      }
      else {
        this.showOtherCommitee = false;
        this.kmpshipForm.controls.OtherCommittee.setValue(null);
      }
    }
    else {
      this.showCommitee = false;
      this.showOtherCommitee = false;
      this.kmpshipForm.controls.CommitteeType.setValue(null);
    }


  }

  kmpshipInsertandUpdate() {
     
    if (this.globalKmpshipID != undefined) {
      this.updateKmpship();
    }
    else {
      this.addKmpship();
    }
  }

  updateKmpship() {
     
    var KmpID = "";
    if (localStorage.getItem('KmpID') != undefined) {
      KmpID = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      KmpID = localStorage.getItem('updateKmpId');
    }
    var updateKmpshipData = {
      "Kmpship": {
        _id: this.globalKmpshipID,//localStorage.getItem('kmpshipId'),
        KmpID: KmpID,
        OfficeName: this.kmpshipForm.controls.OfficeName.value,
        OfficeType: this.kmpshipForm.controls.OfficeType.value,
        CIN: this.kmpshipForm.controls.CIN.value,
        AppointmentDate: this.setDate(this.kmpshipForm.controls.AppointmentDate.value),
        Designation: this.kmpshipForm.controls.Designation.value,
        CessationDate: this.setDate(this.kmpshipForm.controls.CessationDate.value),
        NatureOfIntrest: this.kmpshipForm.controls.NatureOfIntrest.value,
        PAN: this.kmpshipForm.controls.PAN.value,
        ShareHolding: this.kmpshipForm.controls.ShareHolding.value,
        DormantCompany: this.kmpshipForm.controls.DormantCompany.value,
        OtherCompany: this.kmpshipForm.controls.OtherCompany.value,
        OtherDesignation: this.kmpshipForm.controls.OtherDesignation.value,
        OtherNatureOfInterest: this.kmpshipForm.controls.OtherNatureOfInterest.value,
        CommitteeType: this.kmpshipForm.controls.CommitteeType.value,
        OtherCommittee: this.kmpshipForm.controls.OtherCommittee.value,
        IsActive: true,
        IsAuthorize: false,
        IsRectify: false,
        ModifiedBy: null,
        ModifiedDate: null
      }
    }
    this.KmpMasterService.addKmp(updateKmpshipData)
      .subscribe(kmpshipUpdate => {
        if (kmpshipUpdate.status == 0) {
           
          $('#kmpshipDialog').modal('toggle');
          this.clearKmpship();
          //localStorage.removeItem('kmpshipId');
          if (localStorage.getItem('KmpID') != undefined) {
            this.loadKmpshipDetails(localStorage.getItem('KmpID'));
          }
          else if (localStorage.getItem('updateKmpId') != undefined) {
            this.loadKmpshipDetails(localStorage.getItem('updateKmpId'));
          }
          this.alert.success("KMP details updated successfully.");
        }
        else {
          $('#kmpshipDialog').modal('toggle');
          this.alert.error(kmpshipUpdate.message);
        }
      });
  }

  clearKmpship() {
    this.kmpshipForm.controls.OfficeName.setValue('');
    this.kmpshipForm.controls.OfficeType.setValue('');
    this.kmpshipForm.controls.Designation.setValue(null);
    this.kmpshipForm.controls.CIN.setValue('');
    this.kmpshipForm.controls.ShareHolding.setValue('');
    this.kmpshipForm.controls.AppointmentDate.setValue(null);
    this.kmpshipForm.controls.CessationDate.setValue(null);
    this.kmpshipForm.controls.PAN.setValue('');
    this.kmpshipForm.controls.NatureOfIntrest.setValue('');

    this.showShareHolding = false
    this.showDormantState = false
    this.showCIN = false
    this.showOtherCompany = false
    this.showOtherNatureOfInterest = false
    this.showOtherDesignation = false
    this.showCommitee = false
    this.showOtherCommitee = false

  }

  clearSubKmp() {
    this.subKmpForm.controls.CompanyName.setValue('');
    this.subKmpForm.controls.NumberOfSecurities.setValue('');
    this.subKmpForm.controls.SecurityDescription.setValue('');
    this.subKmpForm.controls.SecurityNominalValue.setValue('');
    this.subKmpForm.controls.AcquisitionPaidPrize.setValue('');
    this.subKmpForm.controls.AcquisitionOtherPrize.setValue('');
    this.subKmpForm.controls.NumberOfSharesDisposed.setValue('');
    this.subKmpForm.controls.DisposalPrize.setValue('');
    this.subKmpForm.controls.DisposalReceivedPrize.setValue('');
    this.subKmpForm.controls.CumulativePrize.setValue('');
    this.subKmpForm.controls.AcquisitionSecuritiesMode.setValue('');
    this.subKmpForm.controls.PledgedSecurities.setValue('');
    this.subKmpForm.controls.Shareholding.setValue('');
    this.subKmpForm.controls.AcquisitionDate.setValue(null);
    this.subKmpForm.controls.DisposalDate.setValue(null);
    this.subKmpForm.controls.HoldingMode.setValue(null);
  }

  // loadKmpshipDetails(kmpId) {
  //    
  //   this.KmpMasterService.getKmpDetails(kmpId)
  //     .subscribe(kmp => {
  //        
  //       if (kmp.status == 0) {
  //         var table = $('#kmpshipTable').DataTable({ destroy: true });
  //         table.destroy();
  //         this.kmpshipArray = kmp.kmpDetails[0].KmpshipData;
  //         this.dtTriggerKMPship.next();
  //       }
  //     });
  // }

  // localStorage.getItem('updateKmpId') != undefined && 
  SubkmpInsertUpdate() {
    if (this.globalSubKmpID != undefined) {
      this.updateSubKmp();
    }
    else {
      this.addSubKmp();
    }
  }

  updateSubKmp() {
     
    var newkmpID = "";
    if (localStorage.getItem('KmpID') != undefined) {
      newkmpID = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      newkmpID = localStorage.getItem('updateKmpId');
    }
    var subKmpData = {
      "SubKmp": {
        _id: this.globalSubKmpID,
        KmpID: newkmpID,
        CompanyName: this.subKmpForm.controls.CompanyName.value,
        NumberOfSecurities: this.subKmpForm.controls.NumberOfSecurities.value,
        SecurityDescription: this.subKmpForm.controls.SecurityDescription.value,
        SecurityNominalValue: this.subKmpForm.controls.SecurityNominalValue.value,
        AcquisitionDate: this.setDate(this.subKmpForm.controls.AcquisitionDate.value),
        AcquisitionPaidPrize: this.subKmpForm.controls.AcquisitionPaidPrize.value,
        AcquisitionOtherPrize: this.subKmpForm.controls.AcquisitionOtherPrize.value,
        DisposalDate: this.setDate(this.subKmpForm.controls.DisposalDate.value),
        NumberOfSharesDisposed: this.subKmpForm.controls.NumberOfSharesDisposed.value,
        DisposalPrize: this.subKmpForm.controls.DisposalPrize.value,
        DisposalReceivedPrize: this.subKmpForm.controls.DisposalReceivedPrize.value,
        CumulativePrize: this.subKmpForm.controls.CumulativePrize.value,
        AcquisitionSecuritiesMode: this.subKmpForm.controls.AcquisitionSecuritiesMode.value,
        HoldingMode: this.subKmpForm.controls.HoldingMode.value,
        PledgedSecurities: this.subKmpForm.controls.PledgedSecurities.value,
        Shareholding: this.subKmpForm.controls.Shareholding.value,
        IsActive: true,
        IsAuthorize: false,
        IsRectify: false,
        ModifiedBy: null,
        ModifiedDate: null
      }
    }
    this.KmpMasterService.addKmp(subKmpData)
      .subscribe(subKmpUpdate => {
        if (subKmpUpdate.status == 0) {
           
          $("#subkmpDialog").modal('toggle');
          this.clearSubKmp();
          this.loadsubkmpDetails(newkmpID);
          //localStorage.removeItem('subkmpId');
          this.alert.success("Sub KMP details updated successfully.");
        }
        else {
          $("#subkmpDialog").modal('toggle');
          this.alert.error(subKmpUpdate.message);
        }
      });
  }


  // loadsubkmpDetails(kmpId) {
  //    
  //   this.KmpMasterService.getKmpDetails(kmpId)
  //     .subscribe(kmp => {
  //       if (kmp.status == 0) {
  //         var table = $('#subKmpTable').DataTable({ destroy: true });
  //         table.destroy();
  //         this.subkmpArray = kmp.kmpDetails[0].SubKmpData;
  //         this.dtTriggerSubKMP.next();
  //       }
  //     });
  // }

  openAddSubKmpModal() {
    this.globalSubKmpID = undefined;
    $('#myModalSecuritiesDetailsLabel').html("<i class='fa fa-plus'></i>Add Details of securities held in the Company, its Holding Company, Subsidiaries, Subsidiaries of the Company's Holding Company and Associate Companies:");
    $("#btnSaveUpdateSubKMP").html('<i class="fa fa-save"></i>Save Security Details');
    this.subKmpForm.controls['DisposalDate'].disable();
  }

  fetchSubKmpRow(i) {
    let dt;

    $('#myModalSecuritiesDetailsLabel').html("<i class='fa fa-pencil'></i>Edit Details of securities held in the Company, its Holding Company, Subsidiaries, Subsidiaries of the Company's Holding Company and Associate Companies:");
    $("#btnSaveUpdateSubKMP").html('<i class="fa fa-save"></i>Update Security Details');
    this.subKmpForm.controls.CompanyName.setValue(this.subkmpArray[i].CompanyName);
    this.subKmpForm.controls.NumberOfSecurities.setValue(this.subkmpArray[i].NumberOfSecurities);
    this.subKmpForm.controls.SecurityDescription.setValue(this.subkmpArray[i].SecurityDescription);
    this.subKmpForm.controls.SecurityNominalValue.setValue(this.subkmpArray[i].SecurityNominalValue);
    if (this.subkmpArray[i].AcquisitionDate) {
      dt = new Date(this.setFormatDate(this.subkmpArray[i].AcquisitionDate));
      this.AcquisitionDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    this.subKmpForm.controls.AcquisitionPaidPrize.setValue(this.subkmpArray[i].AcquisitionPaidPrize);
    this.subKmpForm.controls.AcquisitionOtherPrize.setValue(this.subkmpArray[i].AcquisitionOtherPrize);
    if (this.subkmpArray[i].DisposalDate) {
      dt = new Date(this.setFormatDate(this.subkmpArray[i].DisposalDate));
      this.DisposalDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    this.subKmpForm.controls.NumberOfSharesDisposed.setValue(this.subkmpArray[i].NumberOfSharesDisposed);
    this.subKmpForm.controls.DisposalPrize.setValue(this.subkmpArray[i].DisposalPrize);
    this.subKmpForm.controls.DisposalReceivedPrize.setValue(this.subkmpArray[i].DisposalReceivedPrize);
    this.subKmpForm.controls.CumulativePrize.setValue(this.subkmpArray[i].CumulativePrize);
    this.subKmpForm.controls.AcquisitionSecuritiesMode.setValue(this.subkmpArray[i].AcquisitionSecuritiesMode);
    this.subKmpForm.controls.HoldingMode.setValue(this.subkmpArray[i].HoldingMode);
    this.subKmpForm.controls.PledgedSecurities.setValue(this.subkmpArray[i].PledgedSecurities);
    this.subKmpForm.controls.Shareholding.setValue(this.subkmpArray[i].Shareholding);
    //localStorage.setItem('subkmpId', this.subkmpArray[i]._id);

    this.globalSubKmpID = this.subkmpArray[i]._id;
  }

  removeKmpship() {
    //this.directorshipArray.splice(index, 1);
     
    this.KmpMasterService.removeKmpship(this.deleteKmpshipID)
      .subscribe((kmpshipRemove:any) => {
        if (kmpshipRemove.status == 0) {
           
          this.clearKmpship();
          if (localStorage.getItem('KmpID') != undefined) {
            this.loadKmpshipDetails(localStorage.getItem('KmpID'));
          }
          else if (localStorage.getItem('updateKmpId') != undefined) {
            this.loadKmpshipDetails(localStorage.getItem('updateKmpId'));
          }
          $("#deletekmpshipconfirmation").modal('toggle');
          this.alert.success("KMPship details deleted successfully.");
        }
        else {
          this.alert.error(kmpshipRemove.message);
        }
      });
  }

  generateOutput() {
    // console.log("localStorage.getItem('updateKmpId')",localStorage.getItem('updateKmpId'));
    var object = {
      id: localStorage.getItem('updateKmpId'),
      fromDate: this.FromDateModelInKMPship,
      toDate: this.ToDateModelInKMPship,
      date1: this.FromDateModelInSubKMP,
      date2: this.ToDateModelInSubKMP
    }
    this.KmpMasterService.generateKmpDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(localStorage.getItem('updateKmpId'));
          setTimeout(function () {
            self.downloadPdfDocument(localStorage.getItem('updateKmpId'));
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.KmpMasterService.downloadKmpFile(id);
  }
  downloadPdfDocument(id) {
    this.KmpMasterService.downloadKmpPdfDocument(id);
  }
  RemoveSubKmp() {
    //this.directorshipArray.splice(index, 1);
     
    this.KmpMasterService.removeSubKmp(this.deleteSubKmpID)
      .subscribe((subkmpRemove:any) => {
        if (subkmpRemove.status == 0) {
           
          this.clearSubKmp();
          if (localStorage.getItem('KmpID') != undefined) {
            this.loadsubkmpDetails(localStorage.getItem('KmpID'));
          }
          else if (localStorage.getItem('updateKmpId') != undefined) {
            this.loadsubkmpDetails(localStorage.getItem('updateKmpId'));
          }
          $("#deletesubKmpconfirmation").modal('toggle');
          this.alert.success("Sub Director details deleted successfully.");
        }
        else {
          this.alert.error(subkmpRemove.message);
        }
      });
  }


  removeRelatives() {
     
    this.KmpMasterService.removeRelative(this.deleteRelativeID)
      .subscribe((relativesRemove:any) => {
        if (relativesRemove.status == 0) {
           
          if (localStorage.getItem('KmpID') != undefined) {
            this.loadRelativesDetails(localStorage.getItem('KmpID'));
          }
          else if (localStorage.getItem('updateKmpId') != undefined) {
            this.loadRelativesDetails(localStorage.getItem('updateKmpId'));
          }
          $("#deleterelativeconfirmation").modal('toggle');
          this.alert.success("Relative details deleted successfully.");
        }
        else {
          this.alert.error(relativesRemove.message);
        }
      });
  }

  clearAll() {
    this.clearKmpPersonalDetails();
    this.clearProfessionalDetails();
    this.clearContactDetails();
    this.clearKmpship();
    this.clearSubKmp();
    this.clearRelatives();
  }

  aadharNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 12 digits
      if ((ev.target.value + ev.key).length > 12) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  clearkmppersonalDetails() {
    $('#personalConfirmation').modal('toggle');
  }
  clearkmpprofessionalDetails() {
    $('#professionalConfirmation').modal('toggle');
  }
  clearkmpContactDetails() {
    $("#contactConfirmation").modal('toggle');
  }

  removeKmpshipConfirmation(kmpshipID) {
     
    this.deleteKmpshipID = kmpshipID;
    $("#deletekmpshipconfirmation").modal('toggle');
  }

  removeSubKmpConfirmation(subKmpID) {
     
    this.deleteSubKmpID = subKmpID;
    $("#deletesubKmpconfirmation").modal('toggle');
  }
  removeRelativeConfirmation(relativeID) {
     
    this.deleteRelativeID = relativeID;
    $("#deleterelativeconfirmation").modal('toggle');
  }

  getDirector(ev) {
     
    this.directorArray = [];
    var kmpDesignation = ev.target.value;
    if (kmpDesignation == "Managing Director" || kmpDesignation == "Whole Time Director") {
      this.selectDirector = true;
      this.kmpProfessionalForm.controls.DirectorID.setValue('');
      this.KmpMasterService.getDirectorsByDesignation(kmpDesignation)
        .subscribe(director => {
          if (director.status == 0) {
             
            this.directorArray = this.commonFunction.sortByKey(director.directorData, "FirstName");
          }
        });
    }
    else {
      this.directorArray = [];
      this.selectDirector = false;
    }
  }

  setdormantCompany(ev) {
    var typeOfCompany = ev.target.value;
    if (typeOfCompany == "Private Limited Company" || typeOfCompany == "OPC" || typeOfCompany == "Public Unlisted Company") {
      this.showDormantState = true;
      this.kmpshipForm.controls.DormantCompany.setValue('false');
    }
    else {
      this.showDormantState = false;
      this.kmpshipForm.controls.DormantCompany.setValue('false');
    }
  }

  onlyPrize(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9) || (keyCode == 190)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 11) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  cumulativeCalculationOnNumberOfShareDisposed() {
     
    if (this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel) > this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel)) {
      this.IsNumberOfSharesLarge = true;
      this.cumulativeBalanceModel = null;
      return false;
    }
    else if (this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) >= this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel)) {
      this.IsNumberOfSharesLarge = false;
      this.cumulativeBalanceModel = this.commonFunction.formatToCommaSeperatedNumber(this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) - this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel));
      this.IsNumberOfSecurityLess = false;
      //$("#btnaddSubDirectorshipRow").attr('disabled', false);
      return true;
    }
    else if (this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) >= 0 && this.NumberOfSharesDisposedModel == "") {
      this.cumulativeBalanceModel = this.NumberOfSecuritiesModel;
    }
    else if (this.NumberOfSharesDisposedModel == "") {
      this.cumulativeBalanceModel = null;
      this.IsNumberOfSecurityLess = false;
    }
  }

  cumulativeCalculationOnNumberOfSecurities() {
    if (this.NumberOfSharesDisposedModel != "") {
      if (this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) < this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel)) {
        this.IsNumberOfSecurityLess = true;
        this.cumulativeBalanceModel = null;
      }
      else if (this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel) <= this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel)) {
        this.cumulativeBalanceModel = this.commonFunction.formatToCommaSeperatedNumber(this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) - this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel));
        this.IsNumberOfSecurityLess = false;
        this.IsNumberOfSharesLarge = false;
      }
    }
    else {
      this.cumulativeBalanceModel = this.NumberOfSecuritiesModel;
    }
  }

  otherInstitute(ev) {
    if (ev.target.value == "Others") {
      this.IsOtherInstitute = true;
    }
    else {
      this.IsOtherInstitute = false;
    }
  }

  setShareHolding(ev) {
    var natureOfIntrestValue = ev.target.value;
    if (natureOfIntrestValue == "Member") {
      this.showShareHolding = true;
      this.kmpshipForm.controls.ShareHolding.setValue(null);
    }
    else {
      this.showShareHolding = false;
      this.kmpshipForm.controls.ShareHolding.setValue(null);
    }
  }

  setOtherDesignation(ev) {
    var designationValue = ev.target.value;
    if (designationValue == "Others") {
      this.showOtherDesignation = true;
      this.kmpshipForm.controls.OtherDesignation.setValue(null);
    }
    else {
      this.showOtherDesignation = false;
      this.kmpshipForm.controls.OtherDesignation.setValue(null);
    }
  }

  setOtherNatureOfInterest(ev) {
    var natureOfIntrestValue = ev.target.value;
    if (natureOfIntrestValue == "Others") {
      this.showOtherNatureOfInterest = true;
      this.kmpshipForm.controls.OtherNatureOfInterest.setValue(null);
    }
    else {
      this.showOtherNatureOfInterest = false;
      this.kmpshipForm.controls.OtherDesignation.setValue(null);
    }
  }

  setCommittee(ev) {
    var natureOfIntrestIsCommittee = ev.target.value;
    if (natureOfIntrestIsCommittee == "Committee Chairman" || natureOfIntrestIsCommittee == "Committee Member") {
      this.showCommitee = true;
      this.showOtherCommitee = false;
      this.kmpshipForm.controls['CommitteeType'].setValue(null);
      this.kmpshipForm.controls['OtherCommittee'].setValue(null);
    }
    else {

      this.kmpshipForm.controls['CommitteeType'].setValue(null);
      this.kmpshipForm.controls['OtherCommittee'].setValue(null);
      this.showCommitee = false;
      this.showOtherCommitee = false;
    }
  }

  showCommiteeRelative: boolean;
  showOtherCommiteeRelative: boolean;
  setCommitteeRelative(ev) {
    var natureOfIntrestIsCommittee = ev.target.value;
    console.log('natureOfIntrestIsCommittee', natureOfIntrestIsCommittee)
    if (natureOfIntrestIsCommittee == "Committee Chairman" || natureOfIntrestIsCommittee == "Committee Member") {
      this.relativeForm.controls['CommitteeType'].setValue('null');
      this.relativeForm.controls['OtherCommittee'].setValue(null);
      this.showCommiteeRelative = true;
      this.showOtherCommiteeRelative = false;
    }
    else {
      this.showCommiteeRelative = false;
      this.showOtherCommiteeRelative = false;
    }
  }

  setOtherCommitteeRelative(ev) {
    var otherCommitee = ev.target.value;
    if (otherCommitee == "Others") {
      this.showOtherCommiteeRelative = true;
      this.kmpshipForm.controls.OtherCommittee.setValue(null);
      this.showOtherCommiteeRelative = true;
    }
    else {
      this.showOtherCommiteeRelative = false;
    }
  }

  setOtherCommittee(ev) {
    var otherCommitee = ev.target.value;
    if (otherCommitee == "Others") {
      this.showOtherCommitee = true;
      this.kmpshipForm.controls.OtherCommittee.setValue(null);
      this.showOtherCommitee = true;
    }
    else {
      this.showOtherCommitee = false;
    }
  }

  setOtherCompanyInRelative(ev) {
    var otherCompanyValue = ev.target.value;
    if (otherCompanyValue == "Others") {
      this.showOtherCompanyForRelative = true;
      this.relativeForm.controls.OtherCompanyForRelative.setValue(null);
    }
    else {
      this.showOtherCompanyForRelative = false;
      this.relativeForm.controls.OtherCompanyForRelative.setValue(null);
    }
  }

  setCIN(ev) {
    var getTypeOfCompanyForCIN = ev.target.value;
    if (getTypeOfCompanyForCIN == "Private Debt Listed Company" || getTypeOfCompanyForCIN == "Private Limited Company" || getTypeOfCompanyForCIN == "Public Listed Company"
      || getTypeOfCompanyForCIN == "Public Unlisted Company" || getTypeOfCompanyForCIN == "Section 8 Company" || getTypeOfCompanyForCIN == "OPC"
      || getTypeOfCompanyForCIN == "Foreign Company") {
      this.showCIN = true;
      this.kmpshipForm.controls.CIN.setValue(null);
    }
    else {
      this.showCIN = false;
      this.kmpshipForm.controls.CIN.setValue(null);
    }
  }

  setdormantCompanyRelative(ev) {
    var typeOfCompany = ev.target.value;
    if (typeOfCompany == "Private Limited Company" || typeOfCompany == "OPC" || typeOfCompany == "Public Unlisted Company") {
      this.showDormantStateRelative = true;
      this.relativeForm.controls.DormantCompany.setValue('false');
    }
    else {
      this.showDormantStateRelative = false;
      this.relativeForm.controls.DormantCompany.setValue('false');
    }
  }



  setCINRelative(ev) {
    var getTypeOfCompanyForCIN = ev.target.value;
    if (getTypeOfCompanyForCIN == "Private Debt Listed Company" || getTypeOfCompanyForCIN == "Private Limited Company" || getTypeOfCompanyForCIN == "Public Listed Company"
      || getTypeOfCompanyForCIN == "Public Unlisted Company" || getTypeOfCompanyForCIN == "Section 8 Company" || getTypeOfCompanyForCIN == "OPC"
      || getTypeOfCompanyForCIN == "Foreign Company") {
      this.showCINRelative = true;
      this.relativeForm.controls.CIN.setValue(null);
    }
    else {
      this.showCINRelative = false;
      this.relativeForm.controls.CIN.setValue(null);
    }
  }

  setOtherCompany(ev) {
    var otherCompany = ev.target.value;
    if (otherCompany == "Others") {
      this.showOtherCompany = true;
      this.kmpshipForm.controls.OtherCompany.setValue(null);
    }
    else {
      this.kmpshipForm.controls.OtherCompany.setValue(null);
      this.showOtherCompany = false;
    }
  }

  showShareholdingForRelative(ev) {
    if (ev.target.value == "Member") {
      this.showShareholdingInRelative = true;
    }
    else {
      this.showShareholdingInRelative = false;
    }
  }

  onlyAlphabates(ev) {
    var charCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(charCode >= 65 && charCode <= 120) && (charCode != 32 && charCode != 0) && (charCode != 8) && (charCode != 46) && (charCode != 9)
      && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      event.preventDefault();
    }
  }

  otherNatureOfIntrestInRelative(ev) {
    var NatureOfIntrestInRelative = ev.target.value;
    if (NatureOfIntrestInRelative == "Others") {
      this.showOtherNatureForRelative = true;
      this.relativeForm.controls.OtherNatureOfIntrestForRelative.setValue(null);
    }
    else {
      this.relativeForm.controls.OtherNatureOfIntrestForRelative.setValue(null);
      this.showOtherNatureForRelative = false;
    }
  }

  getOtherDesignation(ev) {
    var otherDesignation = ev.target.value;
    if (otherDesignation == "Others") {
      this.showKmpOtherDesignation = true;
      this.kmpProfessionalForm.controls.OtherDesignation.setValue(null);
    }
    else {
      this.showKmpOtherDesignation = false;
      this.kmpProfessionalForm.controls.OtherDesignation.setValue(null);
    }
  }


  tabDisclosureOfInterestOnClickEvent() {
    // setTimeout(() => {
    //   $("#kmpshipTable").DataTable().columns.adjust();
    // });
    // this.dtTriggerKMPship.next();
    this.getKMPshipByParam();
  }

  tabSecurityHeldOnClickEvent() {
    // setTimeout(() => {
    //   $("#subKmpTable").DataTable().columns.adjust();
    // });
    // this.dtTriggerSubKMP.next();
    this.getSubKMPByParam();
  }

  tabRelativeDetailsOnClickEvent() {
    // this.relationArray = [];
    // $("#relationTable").DataTable().destroy();
    // setTimeout(() => {
    //   $("#relationTable").DataTable().columns.adjust();
    // });
    // this.dtTriggerRelative.next();
    this.getRelativeByParam();
  }

  adjustDataTableColumns(tableId) {
    $("#kmpshipTable").DataTable().columns.adjust();
    $("#subKmpTable").DataTable().columns.adjust();
    $("#relationTable").DataTable().columns.adjust();

  }

  countryList: any[];
  getAllNations() {
    // this.kmpPersonalForm.controls.Nationality.setValue("null");
    this.DirectorMasterService.getNations()
      .subscribe((relativeUpdate:any) => {
        console.log(relativeUpdate);
        this.countryList = this.commonFunction.sortByKey(relativeUpdate.countryList, 'Country');
      });
    // this.kmpPersonalForm.controls.Nationality.setValue("null");
  }

  setCessationAndReappointmentDate(ev) {
    this.checkAppointmentDate();
    var appointmentDate = new Date(this.setDate(ev));
    // var setCessationDate = new Date(moment(appointmentDate).add(1, 'days'));
    var setFutureDateByAppointmentDate = new Date(moment(appointmentDate));
    this.FutureCessationDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.FutureReappointmentDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.FutureDIR12FillingDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.kmpProfessionalForm.controls['CessationDate'].enable();
    this.kmpProfessionalForm.controls['ReAppointmentDate'].enable();
    this.kmpProfessionalForm.controls['EformDIR12FilingDate'].enable();
    if (this.EformDIR12FilingDateModel != null) {
      var diffDIR12FillingDateAppointmentDate = (moment(this.AppointmentDateModel).diff(moment(this.EformDIR12FilingDateModel), "days"));
      if (diffDIR12FillingDateAppointmentDate > 0) {
        this.IsDIR12FillingDatePriorInProfessional = true;
      }
      else {
        this.IsDIR12FillingDatePriorInProfessional = false;
      }
    }
    if (this.ReAppointmentDateModel != null) {
      var diffReAppointmentDateAppointmentDate = (moment(this.AppointmentDateModel).diff(moment(this.ReAppointmentDateModel), "days"));
      if (diffReAppointmentDateAppointmentDate > 0) {
        this.IsReappointmentDatePriorInProfessional = true;
      }
      else {
        this.IsReappointmentDatePriorInProfessional = false;
      }
    }
    if (this.CessationDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.AppointmentDateModel).diff(moment(this.CessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInProfessional = true;
      }
      else {
        this.IsCessationDatePriorInProfessional = false;
      }
    }
  }

  convertCommaSeparatedToNumber(number) {

    let convertNumber = number.toString().replace(/\,/g, '');
    if (convertNumber != '') {
      let convertedNumber = parseFloat(convertNumber);
      return convertedNumber;
    }
  }

  getCompanyTypeInDisclosureOfIntrest() {
     
    this.DirectorMasterService.getCompanyType()
      .subscribe((companyType:any) => {
        if (companyType.status == 0) {
          this.bodycorporateArray = companyType.companyTypeList;
        }
        else {
          this.alert.error(companyType.message);
        }
      });
  }

  getNatureOfInterestInDisclosureOfIntrest() {
     
    this.DirectorMasterService.getNatureOfInterest()
      .subscribe((natureOfInterest:any) => {
        if (natureOfInterest.status == 0) {
          this.natureOfIntrestArray = this.commonFunction.sortByKey(natureOfInterest.natureOfInterestList, 'Nature');
        }
        else {
          this.alert.error(natureOfInterest.message);
        }
      });
  }

  setNatureOfIntrest(ev) {
     
    var typeOfCompany = ev.target.value;
    if (typeOfCompany == "") {
      this.getNatureOfInterestInDisclosureOfIntrest();
    }
    this.bodycorporateArray.forEach(element => {
      if (element.BodyCorporate == typeOfCompany) {
        this.natureOfIntrestArray = this.commonFunction.sortByKey(element.NatureOfIntrest, 'Nature');
      }
    });
    this.kmpshipForm.controls.NatureOfIntrest.setValue("");
    this.showShareHolding = false;
    this.showOtherNatureOfInterest = false;
    this.showCommitee = false;
    this.showOtherCommitee = false;
  }

  DIR12FillingDateIsPriorToAppointmentDateInProfessional() {
    if (this.AppointmentDateModel != null) {
      var diffAppointmentDateDIR12FillingDate = (moment(this.AppointmentDateModel).diff(moment(this.EformDIR12FilingDateModel), "days"));
      if (diffAppointmentDateDIR12FillingDate > 0) {
        this.IsDIR12FillingDatePriorInProfessional = true;
      }
      else {
        this.IsDIR12FillingDatePriorInProfessional = false;
      }
    }
  }

  CessationDateIsPriorToAppointmentDateInProfessional() {
    if (this.AppointmentDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.AppointmentDateModel).diff(moment(this.CessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInProfessional = true;
      }
      else {
        this.IsCessationDatePriorInProfessional = false;
      }
    }
  }

  ReappointmentDateIsPriorToAppointmentDateInProfessional() {
    if (this.AppointmentDateModel != null) {
      var diffAppointmentDateReappointmentDate = (moment(this.AppointmentDateModel).diff(moment(this.ReAppointmentDateModel), "days"));
      if (diffAppointmentDateReappointmentDate > 0) {
        this.IsReappointmentDatePriorInProfessional = true;
      }
      else {
        this.IsReappointmentDatePriorInProfessional = false;
      }
    }
  }

  setCessationDateInKMPship(ev) {
    var appointmentDate = new Date(this.setDate(ev));
    var setFutureDateByAppointmentDate = new Date(moment(appointmentDate));
    this.FutureCessationDateInKMPship = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.kmpshipForm.controls['CessationDate'].enable();
    if (this.dirCessationDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.dirAppointmentDateModel).diff(moment(this.dirCessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInKMPship = true;
      }
      else {
        this.IsCessationDatePriorInKMPship = false;
      }
    }
  }

  CessationDateIsPriorToAppointmentDate() {
    if (this.dirAppointmentDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.dirAppointmentDateModel).diff(moment(this.dirCessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInKMPship = true;
      }
      else {
        this.IsCessationDatePriorInKMPship = false;
      }
    }
  }

  //KMPship filter function

  adjustkmpshipTable() {
    // var kmpshipata = this.kmpshipArray;
    // this.kmpshipArray = [];
    // $("#kmpshipTable").DataTable().destroy();
    // this.kmpshipArray = kmpshipata;

    // setTimeout(() => {
    //   $("#kmpshipTable").DataTable().columns.adjust().draw();
    // }, 200);
    // this.dtTriggerKMPship.next();
  }

  getKMPshipByParam() {
     
    this.response = true;
    var kmpId = "";
    this.kmpshipArray = [];
    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInKMPship != null && this.ToDateModelInKMPship == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInKMPship).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInKMPship == null && this.ToDateModelInKMPship != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInKMPship).toString();
    }
    if (this.FromDateModelInKMPship != null && this.ToDateModelInKMPship != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInKMPship).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInKMPship).toString();
    }
    if (this.FromDateModelInKMPship == null && this.ToDateModelInKMPship == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }
    this.kmpshipArray = [];
    $("#kmpshipTable").DataTable().destroy();

    this.KmpMasterService.getKMPshipByDate(filterDate)
      .subscribe(kmpshipDetails => {
        if (kmpshipDetails.status == 0) {
          this.kmpshipArray = kmpshipDetails.kmpshipData;
          this.response = false;
          this.dtTriggerKMPship.next();
        }
        else {
          this.alert.error(kmpshipDetails.message);
        }
      });
    this.adjustkmpshipTable();
    // this.dtTriggerKMPship.next();
  }

  getKMPshipByNullParam() {
    this.response = true;
    var kmpId = "";
    this.FromDateModelInKMPship = null;
    this.ToDateModelInKMPship = null;
    this.futureFromDateInDisclosure = null;
    this.futureToDateInDisclosure = null;
    this.kmpshipArray = [];
    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }

    this.kmpshipArray = [];
    $("#kmpshipTable").DataTable().destroy();
    this.KmpMasterService.getKMPshipByDate(filterDate)
      .subscribe(kmpshipData => {
        if (kmpshipData.status == 0) {
          this.kmpshipArray = kmpshipData.kmpshipData;
          this.response = false;
          this.dtTriggerKMPship.next();
        }
        else {
          this.alert.error(kmpshipData.message);
        }
      });
    // this.dtTriggerKMPship.next();
    this.adjustkmpshipTable();
  }

  getKMPship(callback) {
    var kmpId = "";
    this.FromDateModelInKMPship = null;
    this.ToDateModelInKMPship = null;
    this.kmpshipArray = [];
    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }

    this.kmpshipArray = [];
    $("#kmpshipTable").DataTable().destroy();
    this.KmpMasterService.getKMPship(filterDate)
      .then(response => {
        if (response) {
          callback(response);
        }
      });
    // this.dtTriggerKMPship.next();
    this.adjustkmpshipTable();
  }

  loadKmpshipDetails(kmpId) {
    this.FromDateModelInKMPship = null;
    this.ToDateModelInKMPship = null;
    this.kmpshipArray = [];
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }
    const self = this;
    this.kmpshipArray = [];
    $("#kmpshipTable").DataTable().destroy();
    this.KmpMasterService.getKMPship(filterDate)
      .then(response => {
        if (response) {
          self.kmpshipArray = response.kmpshipData;
          this.dtTriggerKMPship.next();
        }
      });

    this.adjustkmpshipTable();
  }

  //End of KMPship filter function

  // SubKMP Filter function


  adjustsubkmpTable() {
    // var subkmpata = this.subkmpArray;
    // this.subkmpArray = [];
    // $("#subKmpTable").DataTable().destroy();
    // this.subkmpArray = subkmpata;
    // this.dtTriggerSubKMP.next();
    // setTimeout(() => {
    //   $("#subKmpTable").DataTable().columns.adjust().draw();
    // }, 200);

  }

  getSubKMPByParam() {
     
    this.response = true;
    var kmpId = "";
    this.subkmpArray = [];
    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInSubKMP != null && this.ToDateModelInSubKMP == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInSubKMP).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInSubKMP == null && this.ToDateModelInSubKMP != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInSubKMP).toString();
    }
    if (this.FromDateModelInSubKMP != null && this.ToDateModelInSubKMP != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInSubKMP).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInSubKMP).toString();
    }
    if (this.FromDateModelInSubKMP == null && this.ToDateModelInSubKMP == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }
    this.subkmpArray = [];
    $("#subKmpTable").DataTable().destroy();
    this.KmpMasterService.getSubKMPByDate(filterDate)
      .subscribe(subKMPDetails => {
        if (subKMPDetails.status == 0) {
          this.subkmpArray = subKMPDetails.subKMPData;
          this.response = false;
          this.dtTriggerSubKMP.next();
        }
        else {
          this.alert.error(subKMPDetails.message);
        }
      });

    this.adjustsubkmpTable();
  }

  loadsubkmpDetails(kmpId) {
    this.FromDateModelInSubKMP = null;
    this.ToDateModelInSubKMP = null;
    this.subkmpArray = [];
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }
    const self = this;
    this.subkmpArray = [];
    $("#subKmpTable").DataTable().destroy();
    this.KmpMasterService.getSubKMP(filterDate)
      .then(response => {
        if (response) {
          self.subkmpArray = response.subKMPData;
        }
      });
    this.dtTriggerSubKMP.next();
    this.adjustsubkmpTable();
  }

  getSubKMPByNullParam() {
    this.response = true;
    var kmpId = "";
    this.FromDateModelInSubKMP = null;
    this.ToDateModelInSubKMP = null;
    this.futureFromDateInDetailsOfSecurity = null;
    this.futureToDateInDetailsOfSecurity = null;
    this.kmpshipArray = [];
    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }

    this.subkmpArray = [];
    $("#subKmpTable").DataTable().destroy();
    this.KmpMasterService.getSubKMPByDate(filterDate)
      .subscribe(kmpshipData => {
        if (kmpshipData.status == 0) {
          console.log('--->>', kmpshipData.subKMPData);
          this.subkmpArray = kmpshipData.subKMPData;
          this.response = false;
          this.dtTriggerSubKMP.next();
        }
        else {
          this.alert.error(kmpshipData.message);
        }
      });

    this.adjustsubkmpTable();
  }

  getSubKMP(callback) {
    var kmpId = "";
    this.FromDateModelInSubKMP = null;
    this.ToDateModelInSubKMP = null;
    this.subkmpArray = [];
    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }

    this.subkmpArray = [];
    $("#subKmpTable").DataTable().destroy();
    this.KmpMasterService.getSubKMP(filterDate)
      .then(response => {
        if (response) {
          callback(response);
        }
      });
    this.dtTriggerSubKMP.next();
    this.adjustsubkmpTable();
  }

  //End of SubKMP filter function

  //Relative filter function
  adjustrelativeTable() {
    // var relativeData = this.relationArray;

    // this.relationArray = relativeData;

    // setTimeout(() => {
    //   $("#relationTable").DataTable().columns.adjust().draw();
    // });

  }

  getRelativeByParam() {
    this.response = true;
    var kmpId = "";

    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInRelative != null && this.ToDateModelInRelative == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInRelative).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInRelative == null && this.ToDateModelInRelative != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInRelative).toString();
    }
    if (this.FromDateModelInRelative != null && this.ToDateModelInRelative != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInRelative).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInRelative).toString();
    }
    if (this.FromDateModelInRelative == null && this.ToDateModelInRelative == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }
    // this.relativesArray  = [];
    $("#relationTable").DataTable().destroy();
    this.KmpMasterService.getRelativeByDate(filterDate)
      .subscribe(relativeDetails => {
        if (relativeDetails.status == 0) {
          this.relativesArray = relativeDetails.relativesData;
          this.response = false;
          this.dtTriggerRelative.next();
        }
        else {
          this.alert.error(relativeDetails.message);
        }
      });

    // this.adjustrelativeTable();
    // setTimeout(() => {
    //   $("#relationTable").DataTable().columns.adjust().draw();
    // });
  }

  getRelativeByNullParam() {
    this.response = true;
    var kmpId = "";
    this.FromDateModelInRelative = null;
    this.ToDateModelInRelative = null;
    this.futureFromDateInRelative = null;
    this.futureToDateInRelative = null;

    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }

    // this.relativesArray  = [];
    $("#relationTable").DataTable().destroy();
    this.KmpMasterService.getRelativeByDate(filterDate)
      .subscribe(relativeData => {
        if (relativeData.status == 0) {
          this.relativesArray = relativeData.relativesData;
          this.response = false;
          this.dtTriggerRelative.next();
        }
        else {
          this.alert.error(relativeData.message);
        }
      });

    // this.adjustrelativeTable();
    // setTimeout(() => {
    //   $("#relationTable").DataTable().columns.adjust().draw();
    // });
  }

  loadRelativesDetails(kmpId) {
    // this.relativesArray  = [];
    $("#relationTable").DataTable().destroy();

    this.FromDateModelInRelative = null;
    this.ToDateModelInRelative = null;
    this.relativesArray = [];
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }
    const self = this;
    // var table = $('#relationTable').DataTable({ destroy: true });
    // table.destroy();
    this.KmpMasterService.getRelative(filterDate)
      .then(response => {
        if (response) {
          this.relativesArray = response.relativesData;
          this.dtTriggerRelative.next();
        }
      });
    
    // this.adjustrelativeTable();
    // setTimeout(() => {
    //   $("#relationTable").DataTable().columns.adjust().draw();
    // });
  }

  getRelatives(callback) {
    // this.relativesArray = [];
    $("#relationTable").DataTable().destroy();
    var kmpId = "";
    this.FromDateModelInRelative = null;
    this.ToDateModelInRelative = null;
    this.relativesArray = [];
    if (localStorage.getItem('KmpID') != undefined) {
      kmpId = localStorage.getItem('KmpID');
    }
    else if (localStorage.getItem('updateKmpId') != undefined) {
      kmpId = localStorage.getItem('updateKmpId');
    }
    var filterDate = {
      KMPId: kmpId,
      FromDate: null,
      ToDate: null,
    }

    // var table = $('#relativeTable').DataTable({ destroy: true });
    // table.destroy();
    this.KmpMasterService.getRelative(filterDate)
      .then(response => {
        if (response) {
          callback(response);
        }
      });

    // this.adjustrelativeTable();
    // setTimeout(() => {
    //   $("#relationTable").DataTable().columns.adjust().draw();
    // });
  }

  //End relative filter

  setDisposalDateInSubKmp(ev) {
    var acquisitionDate = new Date(this.setDate(ev));
    var setFutureDateByAcquisitionDate = new Date(moment(acquisitionDate));
    this.FutureDisposalDateInSubKmp = { year: setFutureDateByAcquisitionDate.getFullYear(), month: setFutureDateByAcquisitionDate.getMonth() + 1, day: setFutureDateByAcquisitionDate.getDate() };
    this.subKmpForm.controls['DisposalDate'].enable();
    if (this.DisposalDateModel != null) {
      var diffAcquisitionDateAndDisposal = (moment(this.AcquisitionDateModel).diff(moment(this.DisposalDateModel), "days"));
      if (diffAcquisitionDateAndDisposal > 0) {
        this.IsDisposalDatePriorInSubKmp = true;
      }
      else {
        this.IsDisposalDatePriorInSubKmp = false;
      }
    }
  }

  DisposalDateIsPriorToAcquisitionDate() {
    if (this.AcquisitionDateModel != null) {
      var diffAcquisitionDateDisposalDate = (moment(this.AcquisitionDateModel).diff(moment(this.DisposalDateModel), "days"));
      if (diffAcquisitionDateDisposalDate > 0) {
        this.IsDisposalDatePriorInSubKmp = true;
      }
      else {
        this.IsDisposalDatePriorInSubKmp = false;
      }
    }
  }

  ReappointmentDateIsLaterToCessationDate() {
    if (this.CessationDateModel != null) {
      var diffCesationDateReappointmentDate = (moment(this.ReAppointmentDateModel).diff(moment(this.CessationDateModel), "days"));
      if (diffCesationDateReappointmentDate > 0) {
        this.IsReappointmentDateLaterInProfessional = true;
      }
      else {
        this.IsReappointmentDateLaterInProfessional = false;
      }
    }
  }

  aboveEighteenYear() {
    if (this.DateOfBirthModel != null) {
      const date = moment({
        year: +this.DateOfBirthModel.year, month: (+this.DateOfBirthModel.month) - 1, day:
          +this.DateOfBirthModel.day
      }).startOf('day');
      const now = moment().startOf('day');
      if ((now.diff(date, 'years') >= 18) == true) {
        this.isDateOfBirthValid = true;
      }
      else {
        this.isDateOfBirthValid = false;
      }
    }
  }

  setIntrestChangeDateInRelative(ev) {
    if (ev == null) {
      this.IntrestChangeDateModel = null;
      this.relativeForm.controls['IntrestChangeDate'].disable();
      this.IsInterestChangeDatePriorInRelative = false;
      return false;
    }
    var intrestDate = new Date(this.setDate(ev));
    var setFutureDateByIntrestDate = new Date(moment(intrestDate));
    this.FutureIntrestChangeDate = { year: setFutureDateByIntrestDate.getFullYear(), month: setFutureDateByIntrestDate.getMonth() + 1, day: setFutureDateByIntrestDate.getDate() };
    this.relativeForm.controls['IntrestChangeDate'].enable();
    if (this.IntrestChangeDateModel != null) {
      var diffIntrestDateAndIntrestChangeDate = (moment(this.IntrestDateModel).diff(moment(this.IntrestChangeDateModel), "days"));
      if (diffIntrestDateAndIntrestChangeDate > 0) {
        this.IsInterestChangeDatePriorInRelative = true;
      }
      else {
        this.IsInterestChangeDatePriorInRelative = false;
      }
    }
  }

  InterestChangeDateIsPriorToInterestDate() {
    if (this.IntrestChangeDateModel != null) {
      var diffInterestDateIntrestChangeDate = (moment(this.IntrestDateModel).diff(moment(this.IntrestChangeDateModel), "days"));
      if (diffInterestDateIntrestChangeDate > 0) {
        this.IsInterestChangeDatePriorInRelative = true;
      }
      else {
        this.IsInterestChangeDatePriorInRelative = false;
      }
    }
  }

  setTodateInDisclosure(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDateInDisclosure = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdateInDisclosure(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDateInDisclosure = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }

  setTodateInDetailsOfSecurity(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDateInDetailsOfSecurity = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdateInDetailsOfSecurity(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDateInDetailsOfSecurity = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }

  setTodateInRelative(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDateInRelative = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdateInRelative(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDateInRelative = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }

  getInformationOfDirector(directorId) {
    console.log('get the director Information', directorId)
    this.DirectorMasterService.getDirectorDetails(directorId).subscribe((response:any) => {
      console.log('get director details', response)
      if (!response.status) {
        let directorDIN = _.get(_.first(response.directorMasterResult), 'Din')
        console.log('directorMasterResult', _.first(response.directorMasterResult))
        let directorDirectorProfessional = _.first(_.get(_.first(response.directorDetails), 'DirectorProfessional'))
        console.log('directorDirectorProfessional', directorDirectorProfessional)
        let directorBoardResolutionDate = _.get(directorDirectorProfessional, 'BoardResolutionDate')
        console.log("directorBoardResolutionDate" + directorBoardResolutionDate);

        let directorBoardResolutionDateObject = null;
        if (!_.isNil(directorBoardResolutionDate)) {
          directorBoardResolutionDateObject = { year: new Date(directorBoardResolutionDate).getFullYear(), month: new Date(directorBoardResolutionDate).getMonth() + 1, day: new Date(directorBoardResolutionDate).getDate() };
        }


        let directorAppointmentDate = _.get(directorDirectorProfessional, 'AppointmentDate')
        let directorAppointmentDateObject = null;
        if (!_.isNil(directorAppointmentDate)) {

          directorAppointmentDateObject = { year: new Date(directorAppointmentDate).getFullYear(), month: new Date(directorAppointmentDate).getMonth() + 1, day: new Date(directorAppointmentDate).getDate() };
        }
        let directorReAppointmentDate = _.get(directorDirectorProfessional, 'ReAppointmentDate')
        let directorReAppointmentDateObject = null;
        if (!_.isNil(directorReAppointmentDate)) {

          directorReAppointmentDateObject = { year: new Date(directorReAppointmentDate).getFullYear(), month: new Date(directorReAppointmentDate).getMonth() + 1, day: new Date(directorReAppointmentDate).getDate() };
        }
        let directorAppointmentCompletionDate = _.get(directorDirectorProfessional, 'AppointmentCompletionDate')
        let directorAppointmentCompletionDateObject = null;
        if (!_.isNil(directorAppointmentCompletionDate)) {

          directorAppointmentCompletionDateObject = { year: new Date(directorAppointmentCompletionDate).getFullYear(), month: new Date(directorAppointmentCompletionDate).getMonth() + 1, day: new Date(directorAppointmentCompletionDate).getDate() };
        }
        let directorCessationDate = _.get(directorDirectorProfessional, 'CessationDate')
        let directorCessationDateObject = null;
        if (!_.isNil(directorCessationDate)) {

          directorCessationDateObject = { year: new Date(directorCessationDate).getFullYear(), month: new Date(directorCessationDate).getMonth() + 1, day: new Date(directorCessationDate).getDate() };
        }


        // Newly added

        let directorEformDIR12FilingDate = _.get(directorDirectorProfessional, 'AppointmentDIR12FillingDate')
        let directorEformDIR12FilingDateObject = null;
        if (!_.isNil(directorEformDIR12FilingDate)) {

          directorEformDIR12FilingDateObject = { year: new Date(directorEformDIR12FilingDate).getFullYear(), month: new Date(directorEformDIR12FilingDate).getMonth() + 1, day: new Date(directorEformDIR12FilingDate).getDate() };
        }

        // let directorCessationDate = _.get(directorDirectorProfessional, 'CessationDate')
        // let directorCessationDateObject = null;
        // if(!_.isNil(directorCessationDate)){

        //   directorCessationDateObject = {year: new Date(directorCessationDate).getFullYear(), month: new Date(directorCessationDate).getMonth()+1, day: new Date(directorCessationDate).getDate()};
        // }

        // let directorCessationDate = _.get(directorDirectorProfessional, 'CessationDate')
        // let directorCessationDateObject = null;
        // if(!_.isNil(directorCessationDate)){

        //   directorCessationDateObject = {year: new Date(directorCessationDate).getFullYear(), month: new Date(directorCessationDate).getMonth()+1, day: new Date(directorCessationDate).getDate()};
        // }



        console.log('directorBoardResolutionDate', directorBoardResolutionDateObject)
        console.log('directorAppointmentDate', directorBoardResolutionDateObject)
        console.log('directorReAppointmentDate', directorReAppointmentDateObject)
        console.log('directorAppointmentCompletionDate', directorAppointmentCompletionDateObject)
        console.log('directorCessationDate', directorCessationDateObject)
        this.kmpProfessionalForm.controls['Din'].setValue(directorDIN)
        this.kmpProfessionalForm.controls['BoardResolutionDate'].setValue(directorBoardResolutionDateObject)
        this.kmpProfessionalForm.controls['AppointmentDate'].setValue(directorBoardResolutionDateObject)
        this.kmpProfessionalForm.controls['ReAppointmentDate'].setValue(directorReAppointmentDateObject)
        this.kmpProfessionalForm.controls['AppointmentCompletionDate'].setValue(directorAppointmentCompletionDateObject)
        this.kmpProfessionalForm.controls['CessationDate'].setValue(directorCessationDateObject)
        this.kmpProfessionalForm.controls['EformDIR12FilingDate'].setValue(directorEformDIR12FilingDateObject)


      } else {
        console.log('something went wrong')
      }
    })
  }

  isDirector: boolean = false;

  addToDirector() {

    console.log("addd");
    // isKmp
    this.activatedRoute.params.subscribe(params => {
      if (params['kmpId'] != undefined) {
        this.KmpMasterService.addThisKMPAsDirector(params['kmpId'])
          .subscribe(directorData => {
            if (directorData.status == 0) {
              console.log(directorData.CreatedDirector);
              this.alert.successWithOk("KMP Added to Director successfully.", 'director/edit/' + directorData.CreatedDirector);
              localStorage.setItem('checkdin', "checkdin");
            }
            else {
              this.alert.error(directorData.message);
            }
          });
      }
      else {
        this.isDirector = true;
      }

    })

  }


  //If KMP Is Available in Director then Redirect the KMP to Director Module
  redirectKMPToDirector() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['director','edit',this.availableDirectorID]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/director/edit/' + this.availableDirectorID]);
    // 
  }

  checkAppointmentDate() {
    var dateOfIncorporation = JSON.parse(localStorage.getItem('dateOfIncorporation'));
    var appointmentDate = this.kmpProfessionalForm.controls.AppointmentDate.value
    var diffAppointmentDateAndDateOfIncorporation = (moment(dateOfIncorporation).diff(moment(appointmentDate), "days"));
    if (diffAppointmentDateAndDateOfIncorporation > 0) {
      this.disabledAppointmentDate = true;
    }
    else {
      this.disabledAppointmentDate = false;
    }
  }

}

